<template>
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">{{ GetEjecucion }}
   <h1>DGII:Facturación Electrónica</h1> 

   <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="aalert.timeout" :right="aalert.right" :top="aalert.top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
   </v-snackbar>
</v-col>

</template>
<script>
import { EventBus } from "@/event-bus";
import { currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,RedondeoBasico,fechaNueva,getHoraActual,getParamFecha } from "@/js/Funciones.js";
import VueAutonumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    VueAutonumeric
  },
  created() { 
            console.log('created--PVCONFIGU')
  },
  mounted() {
 

  },
  beforeDestroy() {

  },

  data: () => ({  
    //  testecf ,certecf, ecf 
     ambiente:'testecf',
     semilla:null,
     arrayPropiedases: {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: false
    },
    windowSize: { width: "auto", height: "auto" },
    valid: true,
    aalert: {
      estado: false,
      color: null,
      timeout: 3000,
      top: false,
      right: false
      },
    

  }),

  methods: { 
    currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,
    RedondeoBasico,fechaNueva,getHoraActual,getParamFecha,
   
   
    async getAprovacion(){

  //var AMBIENTE='testecf'
  var AMBIENTE= this.ambiente
  var HEADER={'Content-Type': "application/json" }
  var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/aprobacioncomercia`

  return  new Promise((resolve, reject) => {
    this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          console.log(res.data)
          (async () => {  

            var AMBIENTE= this.ambiente
    let texto = res.data
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');   

            resolve(res.data)
         /* const resXMLsellado =  await this.firmarArchivoXML(res.data);
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado);
        //  return resXMLvalidado;
            resolve(resXMLvalidado)*/
          })()
      // 
          })
          .catch((error) => console.log(error));

   });
 


},
   
   
   //BUENO 
async getSemillaValidaGetTokenBUENO(FACTURA){
  var ObjDirecSucursal={
nombreCertDGI:FACTURA.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACTURA.caja.sucursal.passCertDgi,
sucursalRnc:FACTURA.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  //var AMBIENTE='testecf'FACTURA
  // var AMBIENTE= this.ambiente
  var AMBIENTE=FACTURA.sucursal.ambienteDgi!=null?FACTURA.sucursal.ambienteDgi:"testecf";

  var HEADER={'Content-Type': "application/json"}
  var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/autenticacion/api/autenticacion/semilla`

  return  new Promise((resolve, reject) => {
    this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          (async () => {  
          const resXMLsellado =  await this.firmarArchivoXML(res.data,ObjDirecSucursal);
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado,FACTURA);
        //  return resXMLvalidado;
            resolve(resXMLvalidado)
          })()
      // 
          })
          .catch((error) => console.log(error));

   });
 
},


async getSemillaValidaGetToken(FACTURA){
  var DA_SUCURSAL= FACTURA.caja!=null?FACTURA.caja.sucursal:FACTURA.sucursal
  var ObjDirecSucursal={
nombreCertDGI:DA_SUCURSAL.nombreArchivoDgi,
passCertDGI:DA_SUCURSAL.passCertDgi,
sucursalRnc:DA_SUCURSAL.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  //var AMBIENTE='testecf'FACTURA
  // var AMBIENTE= this.ambiente
  var AMBIENTE=DA_SUCURSAL.ambienteDgi!=null?DA_SUCURSAL.ambienteDgi:"testecf";

  var HEADER={
    'Content-Type': "application/json"
  }
  //var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/autenticacion/api/autenticacion/semilla`

var url1=this.$hostname + this.$hName +`/dgii/local/autenticacion/api/Semilla`
// var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/autenticacion/api/autenticacion/semilla`
  return  new Promise((resolve, reject) => {
    this.$axios.get(url1, 
          { headers: HEADER,
             params: {
              ambiente: AMBIENTE
            }
           })
        .then((res) => {
                    
          (async () => {  
          const resXMLsellado =  await this.firmarArchivoXML(res.data,ObjDirecSucursal);
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado,FACTURA);
        //  return resXMLvalidado;
            resolve(resXMLvalidado)
          })()
      // 
          })
          .catch((error) => {
            console.log(error)
          });

   });
 
},

async firmarArchivoXML(XMLSTRING,ObjDirecSucursal){
  var HEADER={'Content-Type': "application/json" }
 return  new Promise((resolve, reject) => {  
  var Obj={
    XMLSTRING:XMLSTRING,
    nombreCertDGI:ObjDirecSucursal.nombreCertDGI,
    passCertDGI:ObjDirecSucursal.passCertDGI,
    sucursalRnc:ObjDirecSucursal.sucursalRnc
  }

  // + "/importData/pruebafimaDgi",XMLSTRING
  this.$axios
        .post(this.$hostname + this.$hName + "/importData/pruebafimaDgi",Obj , { headers: HEADER })
        .then(res1 => {
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });
});

},

//ESTE ES ELBUENO
async varlidarSemillaBUENO(XML,FACT){
  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   // var AMBIENTE= this.ambiente
   var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
    let texto = XML
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');      
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          var TOKEN_SUC=resss.data
          TOKEN_SUC.sucursal=FACT.sucursal.codigo
          this.actualizarToken(TOKEN_SUC)
          this.semilla=resss.data;
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });
},

async varlidarSemilla(XML,FACT){
  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   // var AMBIENTE= this.ambiente
   var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
    let texto = XML
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml'); 
   formData.append('ambiente', AMBIENTE);     
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         //var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
         var url2=this.$hostname + this.$hName +`/dgii/local/autenticacion/api/validacionCertificado`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          var TOKEN_SUC=resss.data
          TOKEN_SUC.sucursal=FACT.sucursal.codigo
          this.actualizarToken(TOKEN_SUC)
          this.semilla=resss.data;
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });
},

// no FUNC SOlo PRUEVA
async varlidarSemillaprrr(XML,FACT){
  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   // var AMBIENTE= this.ambiente
   var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
    let texto = XML
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');  
   formData.append('ambiente', AMBIENTE); 

        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
        // var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
       ///fe/autenticacion/api/validacioncertificado"

       var url2=this.$hostname + this.$hName +`/dgii/local/autenticacion/api/validacioncertificado`
         this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          var TOKEN_SUC=resss.data
          TOKEN_SUC.sucursal=FACT.sucursal.codigo
          this.actualizarToken(TOKEN_SUC)
          this.semilla=resss.data;
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });
},


actualizarToken(TOKEN_SUC){
  this.$axios.post(this.$hostname + this.$hName + "/sucursal/actualizartoken",
  TOKEN_SUC,{ headers: this.$store.getters.GetheadersAxios })
            .then((res) => {
              console.log("actualizartoken guardado correctamente-->",res.data)
            })
            .catch((error) => {
              console.log("actualizartoken no guardado correctamente-->",error)
            });
  //sucursal/actualizartoken
},

getEmisorFactEletroECF(FACTURA){
// var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
//var SocialEmisor=this.$store.getters.GetConfiguracionGeneral.config.nombre.trim();
//var SocialEmisor=FACTURA.sucursal.descripcion.trim()
var SocialEmisor=FACTURA.sucursal.razonSocialDgi.trim()

var FechaEmision=this.FormatoFecha(FACTURA.nuevaFecha);
var Correo = this.$store.getters.GetConfiguracionGeneral.config.email.trim();
var TelefonoEmisor = FACTURA.sucursal.telefono.trim().replace("(", "").replace(")", "-");
 
// console.log('FACsuc-->',FACTURA.sucursal.telefono.trim())
// console.log('TelefonoEmisor-->',TelefonoEmisor)
// 

// <Sucursal>${FACTURA.sucursal.descripcion.trim()}</Sucursal>
var EMISOR=`
    <Emisor>
      <RNCEmisor>${RNCEmisor.replaceAll('&', '&amp;')}</RNCEmisor>
      <RazonSocialEmisor>${SocialEmisor.replaceAll('&', '&amp;')}</RazonSocialEmisor>
      <NombreComercial>${SocialEmisor.replaceAll('&', '&amp;')}</NombreComercial>
      <DireccionEmisor>${FACTURA.sucursal.direccion.trim()}</DireccionEmisor>
        <TablaTelefonoEmisor>
         <TelefonoEmisor>${TelefonoEmisor}</TelefonoEmisor>
        </TablaTelefonoEmisor>
      <CorreoEmisor>${Correo}</CorreoEmisor> 
      <FechaEmision>${FechaEmision}</FechaEmision>
    </Emisor>`
    return EMISOR;

},

getCompradorFactEletroECF_RFCE(FACTURA,tipoDocumento){
 /* console.log('Comprador-FACTURA->',FACTURA)
   console.log('Comprador-nombreDgii->',FACTURA.nombreDgii)
  console.log('Comprador-cedularncncf->',FACTURA.cedularncncf)*/
//.replaceAll(".","").replaceAll(",","").replaceAll("-","")
 var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
if (tipoDocumento != null) TipoeCF = tipoDocumento;
var SocialComprador=  FACTURA.nombreDgii==null || FACTURA.nombreDgii.trim().length==0?'CONTADO':FACTURA.nombreDgii.trim().toUpperCase();
  var RNCComprador= FACTURA.cedularncncf!=null? FACTURA.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  if(RNCComprador.length==0 && !FACTURA.ncf.includes("E32") && FACTURA.cliente!=null && FACTURA.cliente.cedrnc!=null && FACTURA.cliente.cedrnc.trim().length> 0){
    RNCComprador=FACTURA.cliente.cedrnc.trim().replace("-", "").replace(/-/g,'')
  }
 var COMPRADOR=String(TipoeCF)==="32"?"<Comprador/>":""
 if(RNCComprador.trim().length>0){
  COMPRADOR=`
    <Comprador>
      <RNCComprador>${RNCComprador.replaceAll('&', '&amp;')}</RNCComprador>
      <RazonSocialComprador>${SocialComprador.replaceAll('&', '&amp;')}</RazonSocialComprador> ${TipoeCF==46?this.getInformacionesAdicionales(FACTURA):''}
      </Comprador>`
 }
    return COMPRADOR;

},


getInformacionesAdicionales(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';


  var INF_ADIC=""
 if(TipoeCF==46){
  INF_ADIC=`
    <InformacionAdicionalComprador>
    ${FACTURA.hasOwnProperty('infAdicionales')&& FACTURA.infAdicionales!=null? FACTURA.infAdicionales : 'NO INF.' }
    </InformacionAdicionalComprador>`
 }
    return INF_ADIC;
  
},



getTotalFactDevNoItbisEletroECF(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2).toFixed(2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTALXML=''

   var TOTAL=`
<Totales>
<MontoExento>${MontoTotal}</MontoExento>
<MontoTotal>${MontoTotal}</MontoTotal>
</Totales>
  `
return TOTAL.replaceAll("-0", "0");

},

getTotalFactEletroECF_TIPO46(FACTURA){

  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2).toFixed(2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTALXML=''

var total=`
<Totales>
<MontoGravadoTotal>${MontoTotal}</MontoGravadoTotal>
<MontoGravadoI3>${MontoTotal}</MontoGravadoI3>
<ITBIS3>0</ITBIS3>
<TotalITBIS>0.00</TotalITBIS>
<TotalITBIS3>0.00</TotalITBIS3>
<MontoTotal>${MontoTotal}</MontoTotal>
</Totales>`

if(FACTURA.hasOwnProperty('cliente') && FACTURA.cliente!=null &&  FACTURA.cliente.hasOwnProperty('moneda') && FACTURA.cliente.moneda!=null &&
FACTURA.moneda.codigo!=FACTURA.cliente.moneda.codigo){
var OT_MONEDA=FACTURA.cliente.moneda
  var OtraMoneda=`
  <OtraMoneda>
	<TipoMoneda>${OT_MONEDA.nombrecorto!=null?OT_MONEDA.nombrecorto.trim():""}</TipoMoneda>
	<TipoCambio>${this.RedondeoValorCantRed(OT_MONEDA.tasaVenta,2).toFixed(2)}</TipoCambio>
  ${MontoTotal>0?`<MontoGravadoTotalOtraMoneda>${this.RedondeoValorCantRed(MontoTotal/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravadoTotalOtraMoneda>`:""}
  ${MontoTotal>0?`<MontoGravado3OtraMoneda>${this.RedondeoValorCantRed(MontoTotal/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravado3OtraMoneda>`:""}
  <TotalITBISOtraMoneda>0.00</TotalITBISOtraMoneda>
  <TotalITBIS3OtraMoneda>0.00</TotalITBIS3OtraMoneda>
  <MontoTotalOtraMoneda>${this.RedondeoValorCantRed(MontoTotal/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoTotalOtraMoneda>
	</OtraMoneda>`

  total+=OtraMoneda
}

return total;

},

getTotalFactEletroECF(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
  // MontoGravadoTotal:total de todos los itbis
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;

  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2).toFixed(2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTALXML=''
  console.log('MontoTotal--->',MontoTotal)
  var MontoGravadoTotal=0.00
  //var ITBIS18=FACTURA.valorimpuesto!=null ? JSON.parse(JSON.stringify(this.RedondeoValorCantRed(FACTURA.valorimpuesto,2))):0
  var ITBIS18=0.00;
  var ITBIS16=0.00; 
  var ITBIS0=0.00;
  var valorMontoExento=0.00;
  var MontoExento='';
  var ValorPagar='';
var ListDet= FACTURA.ListDet.filter((ee) => ee.impuesto ==null || ee.valorimpuesto==0);
Promise.all(ListDet.map(async (element) => {
  valorMontoExento+= (this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
 }));
 

 var MontoNoFacturable="";
 var ListOfferta= FACTURA.ListDet.filter((ee) => ee.precio ==0);
if(ListOfferta.length>0){
  MontoNoFacturable=`
  <MontoNoFacturable>0</MontoNoFacturable>
  `
}
console.log('ver-ListOfferta->',ListOfferta)
console.log('ver-valorMontoExento->',valorMontoExento)

 var MontoGravadoI1=0.00;
 var MontoGravadoI2=0.00;
 var MontoGravadoI3=0.00;
 Promise.all(FACTURA.ListDet.filter((ee) => ee.impuesto !=null && ee.impuesto.hasOwnProperty("tasa")).map(async (element) => {

    if(element.impuesto.tasa==18){

      ITBIS18+=(element.valorimpuesto*element.cantidad)
        if(IncluirItbisGeneral==false){
          MontoGravadoI1+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))  
        }else{
          //var TASA=(1+(element.impuesto.tasa/100));
          MontoGravadoI1+=(this.RedondeoValorCantRed(((element.cantidad*(element.precio/1.18))-element.valordescuento),2)) 

          
        }
      
    }
    if(element.impuesto.tasa==16){
        ITBIS16+=(element.valorimpuesto*element.cantidad)
        if(IncluirItbisGeneral==false){
          MontoGravadoI2+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
        }else{
          MontoGravadoI2+=(this.RedondeoValorCantRed(((element.cantidad*(element.precio/1.16))-element.valordescuento),2)) 
          
        } 
    }
    if(element.impuesto.tasa==0){
       MontoGravadoI3+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
       ITBIS0+=(element.valorimpuesto*element.cantidad)
    }
 }));

 var cobertura=0;
 var VALOR_DESC_COBERTURA18=0;
 var VALOR_DESC_COBERTURA16=0;
 var VALOR_DESC_COBERTURA0=0;
 var VALOR_DESC_COBERTURAExento=0;
  var VALOR_DESC_COBERTURA_NO_FACT=0;
  if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){
     cobertura=FACTURA.cobertura
   // COBVALOR=FACTURA.cobertura
  //  FACTURA.facturasventaDetalleList
   var MONTO_GENERAL=0 // OTRA FORMA(FACTURA.valor+FACTURA.cobertura)
   var ListDetCOB=JSON.parse(JSON.stringify(FACTURA.ListDet))
    // Promise.all(ListDetCOB.map(async (element) => {
    //   MONTO_GENERAL+=((element.cantidad*precio)-(element.valordescuento));
    // }));
    MONTO_GENERAL=(FACTURA.valor+FACTURA.cobertura)

    Promise.all(ListDetCOB.map(async (element) => {
       var IND_FACT=0
    if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
   }else{IND_FACT=4}
    if(TipoeCF==44){IND_FACT=4}
    if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
      IND_FACT=4
    }
    
  var PROPORCION=((element.cantidad*element.precio) / MONTO_GENERAL);
  var ADESCONTAR= (FACTURA.cobertura * PROPORCION)
  var VALOR_COBERTURA= ((element.cantidad*element.precio) - ADESCONTAR)

    if(IND_FACT==1){VALOR_DESC_COBERTURA18+=((element.cantidad*element.precio)-VALOR_COBERTURA)}
    if(IND_FACT==2){VALOR_DESC_COBERTURA16+=((element.cantidad*element.precio)-VALOR_COBERTURA)}
    if(IND_FACT==3){VALOR_DESC_COBERTURA0+=((element.cantidad*element.precio)-VALOR_COBERTURA)}
    if(IND_FACT==4){VALOR_DESC_COBERTURAExento+=((element.cantidad*element.precio)-VALOR_COBERTURA)}

    if(MontoTotal==0 && TotalItbis==0){
     //   VALOR_DESC_COBERTURA_NO_FACT+=(element.cantidad*element.precio);
      }
      
    }));

    // if(VALOR_DESC_COBERTURA18>0){ MontoGravadoI1=(MontoGravadoI1-VALOR_DESC_COBERTURA18)}
    // if(VALOR_DESC_COBERTURA16>0){ MontoGravadoI2=(MontoGravadoI2-VALOR_DESC_COBERTURA16)}
    // if(VALOR_DESC_COBERTURA0>0){ MontoGravadoI3=(MontoGravadoI3-VALOR_DESC_COBERTURA0)}
    // if(VALOR_DESC_COBERTURAExento>0){ MontoExento=(MontoExento-VALOR_DESC_COBERTURAExento)}
  
    /*E310000001355
    PARA  ITBIS18:(element.cantidad *((element.precioDig - (element.DescValor / element.cantidad))*(element.productos.impuesto.tasa / 100)))
    Y PARA MontoGravadoI1: ((1*(prec/1.18))-desc) = ((1*(1689.99/1.18))-1182.99)
    */
if(VALOR_DESC_COBERTURA18>0){ 
console.log(`MontoGravadoI1:${MontoGravadoI1}--> COBERTURA:${VALOR_DESC_COBERTURA18}`)
  if(MontoTotal==0){
      MontoGravadoI1=	(0.00)  
  }else{
  var VALOR_PRECIO18=(MontoGravadoI1+ITBIS18)
  if((MontoGravadoI1-VALOR_DESC_COBERTURA18)<0){
      MontoGravadoI1=	(VALOR_PRECIO18-VALOR_DESC_COBERTURA18) 
  }else{
 MontoGravadoI1=	(MontoGravadoI1-VALOR_DESC_COBERTURA18)
  }
 
  
  }
    

  /*console.log('VALOR_DESC_COBERTURA18-->',VALOR_DESC_COBERTURA18)
  console.log('VALOR_PRECIO18-->',VALOR_PRECIO18)
  console.log('MontoGravadoI1-->',MontoGravadoI1)
  console.log('ITBIS18-->',ITBIS18)
console.log(`MontoGravadoI1-->((${VALOR_PRECIO18} / 1.18) * (1-(${VALOR_DESC_COBERTURA18} / ${VALOR_PRECIO18})))`)*/


/*Concepto Fórmula Resultado IA
MontoGravadoI2=	(MontoItem / 1.16) × (1 - (Descuento / MontoItem))=3,184.48
TotalITBIS2 =(MontoItem - Descuento) - MontoGravadoI2 = 509.52*/

//MontoGravadoI1=((1*(VALOR_PRECIO18/1.18))-VALOR_DESC_COBERTURA18)

/*console.log(`ITBIS18=(1 *((${VALOR_PRECIO18} - (${VALOR_DESC_COBERTURA18} / 1))*(18 / 100)))`)
console.log(`MontoGravadoI1=((1*(${VALOR_PRECIO18}/1.18))-${VALOR_DESC_COBERTURA18})`)*/
// ITBIS18=(1 *((VALOR_PRECIO18 - (VALOR_DESC_COBERTURA18 / 1))*(18 / 100)))
 // MontoGravadoI1=((1*(VALOR_PRECIO18/1.18))-VALOR_DESC_COBERTURA18)
}

if(VALOR_DESC_COBERTURA16>0){ 
  var VALOR_PRECIO16=(MontoGravadoI2+ITBIS16)
  
if((MontoGravadoI2-VALOR_DESC_COBERTURA16)<0){
    MontoGravadoI2=	(VALOR_PRECIO16-VALOR_DESC_COBERTURA16)
}else{
      MontoGravadoI2=	(MontoGravadoI2-VALOR_DESC_COBERTURA16)
}
}

if(VALOR_DESC_COBERTURA0>0){ 
var VALOR_PRECIO0=(MontoGravadoI3+ITBIS0)
 
  if((MontoGravadoI3-VALOR_DESC_COBERTURA0)<0){
     MontoGravadoI1=	(VALOR_PRECIO0-VALOR_DESC_COBERTURA0)
  }else{
     MontoGravadoI1=	(MontoGravadoI3-VALOR_DESC_COBERTURA0)
  }
}

  }

if(TipoeCF==44){
  MontoExento=`
  <MontoExento>${MontoTotal}</MontoExento>
  `
  //  MontoExento=`
  //   <MontoExento>${(valorMontoExento-cobertura).toFixed(2)}</MontoExento>
  //`
}else{
  if(valorMontoExento>0){
//PR COBERTURA 100% (TipoeCF==32?VALOR_DESC_COBERTURAExento:0.00)
       MontoExento=`
      <MontoExento>${(valorMontoExento-(VALOR_DESC_COBERTURAExento)).toFixed(2)}</MontoExento>
      `
      //<MontoExento>${(valorMontoExento-cobertura).toFixed(2)}</MontoExento>
    // console.log(`<MontoExento-->${valorMontoExento}-${VALOR_DESC_COBERTURAExento}`)
    // if(MontoTotal==0 && (valorMontoExento-VALOR_DESC_COBERTURAExento)<=0){
    // MontoExento=`
    //   <MontoExento>0.00</MontoExento>
    //   `
    // }else{
    // }

  
    }
 
}


  if(TotalItbis>0){
  if(IncluirItbisGeneral==false){
    // TOTALXML+=`<MontoGravadoTotal>${  this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)  }</MontoGravadoTotal>`
    // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}
   
     TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2).toFixed(2)}</MontoGravadoTotal>`
     if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2).toFixed(2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2).toFixed(2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2).toFixed(2)}</MontoGravadoI3>`}
       TOTALXML+=`${MontoExento}`
    if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}

    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2).toFixed(2)}</TotalITBIS>`

    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2).toFixed(2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2).toFixed(2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2).toFixed(2)}</TotalITBIS3>`}
  }else{

     /* MontoGravadoI1=(MontoGravadoI1-ITBIS18);
      MontoGravadoI2=(MontoGravadoI2-ITBIS16);
      MontoGravadoI3=(MontoGravadoI3-ITBIS0);*/

    //TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoTotal>`
   // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}
   TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2).toFixed(2)}</MontoGravadoTotal>`
   if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2).toFixed(2)}</MontoGravadoI1>`}
   if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2).toFixed(2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2).toFixed(2)}</MontoGravadoI3>`}
       TOTALXML+=`${MontoExento}`
    //-------------------------------------------------- 
    if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}
    //---------------------------------------------------- 
    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2).toFixed(2)}</TotalITBIS>`
//  if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(TotalItbis,2)}</TotalITBIS1>`}
    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2).toFixed(2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2).toFixed(2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2).toFixed(2)}</TotalITBIS3>`}
  //MontoTotal= this.RedondeoValorCantRed((MontoTotal-FACTURA.valorimpuesto),2)
  
  }
}else{
TOTALXML+=`${MontoExento}`
}

// TOTALXML+=`<MontoTotal>${FACTURA.valor}</MontoTotal>`

if(TipoeCF==44){
  ValorPagar=`
  <ValorPagar>${MontoTotal}</ValorPagar>
  `
}
 
if(MontoTotal==0){
  // MontoNoFacturable=`<MontoNoFacturable>1.00</MontoNoFacturable>`
}
/* ESTO ES PR COBERTURA 100% var valorMontoFAC=0.00;
Promise.all( FACTURA.ListDet.map(async (element) => {
valorMontoFAC+= (this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
 }));


 if(cobertura>0 && MontoTotal==0 && TipoeCF!=32){
console.log('ver-valorMontoFAC->',valorMontoFAC)
MontoTotal=valorMontoFAC
 }*/

  var TOTAL=`
  <Totales>
       ${TOTALXML} 
      <MontoTotal>${MontoTotal>0?MontoTotal:`0.00`}</MontoTotal>${MontoNoFacturable}${ValorPagar} 
      ${VALOR_DESC_COBERTURA_NO_FACT>0?`<MontoNoFacturable>${(VALOR_DESC_COBERTURA_NO_FACT).toFixed(2)}</MontoNoFacturable>`:``}
    </Totales>
  `
// <MontoExento>${MontoTotal}</MontoExento>
if(FACTURA.hasOwnProperty('cliente') && FACTURA.cliente!=null &&  FACTURA.cliente.hasOwnProperty('moneda') && FACTURA.cliente.moneda!=null &&
FACTURA.moneda.codigo!=FACTURA.cliente.moneda.codigo){
var OT_MONEDA=FACTURA.cliente.moneda
var M_G_T_O_M=(MontoGravadoI1+MontoGravadoI2+MontoGravadoI3);
var T_I_O_M=(ITBIS18+ITBIS16+ITBIS0);
var M_E_O_M=(valorMontoExento-VALOR_DESC_COBERTURAExento)
  var OtraMoneda=`
  <OtraMoneda>
	<TipoMoneda>${OT_MONEDA.nombrecorto!=null?OT_MONEDA.nombrecorto.trim():""}</TipoMoneda>
	<TipoCambio>${this.RedondeoValorCantRed(OT_MONEDA.tasaVenta,2).toFixed(2)}</TipoCambio>
  ${M_G_T_O_M>0?`<MontoGravadoTotalOtraMoneda>${this.RedondeoValorCantRed(M_G_T_O_M/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravadoTotalOtraMoneda>`:""}
  ${MontoGravadoI1>0?`<MontoGravado1OtraMoneda>${this.RedondeoValorCantRed(MontoGravadoI1/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravado1OtraMoneda>`:""}
  ${MontoGravadoI2>0?`<MontoGravado2OtraMoneda>${this.RedondeoValorCantRed(MontoGravadoI2/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravado2OtraMoneda>`:""}
  ${MontoGravadoI3>0?`<MontoGravado3OtraMoneda>${this.RedondeoValorCantRed(MontoGravadoI3/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoGravado3OtraMoneda>`:""}
  ${M_E_O_M>0?`<MontoExentoOtraMoneda>${this.RedondeoValorCantRed(M_E_O_M/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoExentoOtraMoneda>`: ""}
  ${T_I_O_M>0?`<TotalITBISOtraMoneda>${this.RedondeoValorCantRed(T_I_O_M/OT_MONEDA.tasaVenta,2).toFixed(2)}</TotalITBISOtraMoneda>`: ""}
  ${ITBIS18>0?`<TotalITBIS1OtraMoneda>${this.RedondeoValorCantRed(ITBIS18/OT_MONEDA.tasaVenta,2).toFixed(2)}</TotalITBIS1OtraMoneda>`: ""}
  ${ITBIS16>0?`<TotalITBIS2OtraMoneda>${this.RedondeoValorCantRed(ITBIS16/OT_MONEDA.tasaVenta,2).toFixed(2)}</TotalITBIS2OtraMoneda>`: ""}
  ${ITBIS0>0?`<TotalITBIS3OtraMoneda>${this.RedondeoValorCantRed(ITBIS0/OT_MONEDA.tasaVenta,2).toFixed(2)}</TotalITBIS3OtraMoneda>`: ""}
  <MontoTotalOtraMoneda>${this.RedondeoValorCantRed(MontoTotal/OT_MONEDA.tasaVenta,2).toFixed(2)}</MontoTotalOtraMoneda>
	</OtraMoneda>`
  TOTAL+=OtraMoneda
}

  return TOTAL.replaceAll("-0", "0");

/* NOTAS:
<MontoGravadoTotal>350765.00</MontoGravadoTotal>
(<MontoGravadoI1>+<MontoGravadoI2>+<MontoGravadoI3>)
(269805.00+80190.00+770.00) = 350765
--
<MontoExento>1625.00</MontoExento>
--
<TotalITBIS>61395.30</TotalITBIS>
(<TotalITBIS1>+<TotalITBIS2>+<TotalITBIS3>)
(48564.90+12830.40+0.00)=61395.3
--
(<MontoGravadoTotal>+<TotalITBIS>+<MontoExento>)
(350765.00+61395.30+1625.00)=413785.3
<MontoTotal>413785.30</MontoTotal>
*/ 

},
getDescuentoCobertura(FACTURA){

  //console.log('VIENDO-getDescuentoCobertura->',FACTURA)
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
  var Desc=``
  var DescuentoCobertura=``
  var NumeroLinea=1
 var ListDet=JSON.parse(JSON.stringify(FACTURA.facturasventaDetalleList))
 var MONTO_GENERAL=0
 var VALOR_DESC_COBERTURA18=0;
 var VALOR_DESC_COBERTURA16=0;
 var VALOR_DESC_COBERTURA0=0;
 var VALOR_DESC_COBERTURAExento=0;

 Promise.all(ListDet.map(async (element) => {
   var IND_FACT=0
 MONTO_GENERAL+=((element.cantidad*element.precio)-(element.valordescuento));
  if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }
if(TipoeCF==44){IND_FACT=4}
if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
      IND_FACT=4
    }
    
    if(IND_FACT==1){VALOR_DESC_COBERTURA18+=(element.cantidad*element.precio)}
    if(IND_FACT==2){VALOR_DESC_COBERTURA16+=(element.cantidad*element.precio)}
    if(IND_FACT==3){VALOR_DESC_COBERTURA0+=(element.cantidad*element.precio)}
    if(IND_FACT==4){VALOR_DESC_COBERTURAExento+=(element.cantidad*element.precio)}

}));


if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){

   var PROPORCION=0;
   var ADESCONTAR=0;
   var VALOR_COBERTURA=0;

if(VALOR_DESC_COBERTURA18>0){
  PROPORCION=((VALOR_DESC_COBERTURA18) / MONTO_GENERAL);
  ADESCONTAR= (FACTURA.cobertura * PROPORCION)
  VALOR_COBERTURA= ((VALOR_DESC_COBERTURA18) - ADESCONTAR)

   Desc+=`
      <DescuentoORecargo> 
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	   <TipoAjuste>D</TipoAjuste>
      <DescripcionDescuentooRecargo>D</DescripcionDescuentooRecargo>
      <TipoValor>$</TipoValor>
      <MontoDescuentooRecargo>${this.RedondeoValorCantRed((VALOR_DESC_COBERTURA18-VALOR_COBERTURA),2).toFixed(2)}</MontoDescuentooRecargo>
      <IndicadorFacturacionDescuentooRecargo>1</IndicadorFacturacionDescuentooRecargo>
	 </DescuentoORecargo>
    `  
}

if(VALOR_DESC_COBERTURA16>0){
  PROPORCION=((VALOR_DESC_COBERTURA16) / MONTO_GENERAL);
  ADESCONTAR= (FACTURA.cobertura * PROPORCION)
  VALOR_COBERTURA= ((VALOR_DESC_COBERTURA16) - ADESCONTAR)

   Desc+=`
      <DescuentoORecargo> 
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	   <TipoAjuste>D</TipoAjuste>
      <DescripcionDescuentooRecargo>D</DescripcionDescuentooRecargo>
      <TipoValor>$</TipoValor>
      <MontoDescuentooRecargo>${this.RedondeoValorCantRed(VALOR_DESC_COBERTURA18-VALOR_COBERTURA,2).toFixed(2)}</MontoDescuentooRecargo>
      <IndicadorFacturacionDescuentooRecargo>2</IndicadorFacturacionDescuentooRecargo>
	 </DescuentoORecargo>
    `  
}

if(VALOR_DESC_COBERTURA0>0){
  PROPORCION=((VALOR_DESC_COBERTURA0) / MONTO_GENERAL);
  ADESCONTAR= (FACTURA.cobertura * PROPORCION)
  VALOR_COBERTURA= ((VALOR_DESC_COBERTURA0) - ADESCONTAR)

   Desc+=`
      <DescuentoORecargo> 
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	   <TipoAjuste>D</TipoAjuste>
      <DescripcionDescuentooRecargo>D</DescripcionDescuentooRecargo>
      <TipoValor>$</TipoValor>
      <MontoDescuentooRecargo>${this.RedondeoValorCantRed(VALOR_DESC_COBERTURA0-VALOR_COBERTURA,2).toFixed(2)}</MontoDescuentooRecargo>
      <IndicadorFacturacionDescuentooRecargo>3</IndicadorFacturacionDescuentooRecargo>
	 </DescuentoORecargo>
    `  
}

if(VALOR_DESC_COBERTURAExento>0){
  PROPORCION=((VALOR_DESC_COBERTURAExento) / MONTO_GENERAL);
  ADESCONTAR= (FACTURA.cobertura * PROPORCION)
  VALOR_COBERTURA= ((VALOR_DESC_COBERTURAExento) - ADESCONTAR)

   Desc+=`
      <DescuentoORecargo> 
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	   <TipoAjuste>D</TipoAjuste>
      <DescripcionDescuentooRecargo>D</DescripcionDescuentooRecargo>
      <TipoValor>$</TipoValor>
      <MontoDescuentooRecargo>${this.RedondeoValorCantRed(VALOR_DESC_COBERTURAExento-VALOR_COBERTURA,2).toFixed(2)}</MontoDescuentooRecargo>
      <IndicadorFacturacionDescuentooRecargo>4</IndicadorFacturacionDescuentooRecargo>
	 </DescuentoORecargo>
    `  
}


if((VALOR_DESC_COBERTURA18+VALOR_DESC_COBERTURA16+VALOR_DESC_COBERTURA0+VALOR_DESC_COBERTURAExento)>0){
  DescuentoCobertura=`
<DescuentosORecargos>${Desc}
</DescuentosORecargos>
`
}

  }

  return DescuentoCobertura;
},

getTotalFactEletroRFCE(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
  // MontoGravadoTotal:total de todos los itbis
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valor,2).toFixed(2);
  var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTALXML=''

  var MontoGravadoTotal=0.00
  //var ITBIS18=FACTURA.valorimpuesto!=null ? JSON.parse(JSON.stringify(this.RedondeoValorCantRed(FACTURA.valorimpuesto,2))):0
  var ITBIS18=0.00;
  var ITBIS16=0.00; 
  var ITBIS0=0.00;
  var valorMontoExento=0.00;
  var MontoExento='';
  var ValorPagar='';
    var ValorNofacturable=0;

var ListDet= FACTURA.ListDet.filter((ee) => ee.impuesto ==null);
Promise.all(ListDet.map(async (element) => {
  valorMontoExento+= (this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
 }));

 if(MontoTotal==0 && TotalItbis==0){
  Promise.all(FACTURA.ListDet.map(async (element) => {
  ValorNofacturable+= (this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
 }));
 }
  
 var MontoNoFacturable="";
 var ListOfferta= FACTURA.ListDet.filter((ee) => ee.precio ==0);
if(ListOfferta.length>0){
  MontoNoFacturable=`
  <MontoNoFacturable>0</MontoNoFacturable>
  `
}
if(ValorNofacturable>0){
   MontoNoFacturable=`
  <MontoNoFacturable>${(ValorNofacturable).toFixed(2)}</MontoNoFacturable>
  `
}

 var MontoGravadoI1=0.00;
 var MontoGravadoI2=0.00;
 var MontoGravadoI3=0.00;
 Promise.all(FACTURA.ListDet.filter((ee) => ee.impuesto !=null && ee.impuesto.hasOwnProperty("tasa")).map(async (element) => {

    if(element.impuesto.tasa==18){

      ITBIS18+=(element.valorimpuesto*element.cantidad)
        if(IncluirItbisGeneral==false){
          MontoGravadoI1+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))  
        }else{
          //var TASA=(1+(element.impuesto.tasa/100));
           console.log(`ITBIS18+=(${element.valorimpuesto}*${element.cantidad})`)
          console.log(`MontoGravadoI1+=((${element.cantidad}* ((${element.precio}/1.18)-${element.valordescuento}))`)
        //  MontoGravadoI1+=(this.RedondeoValorCantRed((element.cantidad* ((element.precio/1.18)-element.valordescuento)),2)) 
          MontoGravadoI1+=(this.RedondeoValorCantRed(( (element.cantidad*(element.precio/1.18))-element.valordescuento),2)) 
        }
      
    }
    if(element.impuesto.tasa==16){
        ITBIS16+=(element.valorimpuesto*element.cantidad)
        if(IncluirItbisGeneral==false){
          MontoGravadoI2+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
        }else{
        //  MontoGravadoI2+=(this.RedondeoValorCantRed(((element.cantidad*((element.precio/1.16)-element.valordescuento)),2)) )
        MontoGravadoI2+=(this.RedondeoValorCantRed(( (element.cantidad*(element.precio/1.16))-element.valordescuento),2)) 
      } 
    }
    if(element.impuesto.tasa==0){
       MontoGravadoI3+=(this.RedondeoValorCantRed(((element.cantidad*element.precio)-element.valordescuento),2))
       ITBIS0+=(element.valorimpuesto*element.cantidad)
    }
 }));

 var cobertura=0;
  if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){
    cobertura=FACTURA.cobertura
  }


  if(valorMontoExento>0){
 MontoExento=`
  <MontoExento>${(valorMontoExento-cobertura).toFixed(2)}</MontoExento>
  `
  }  


  if(TotalItbis>0){
  if(IncluirItbisGeneral==false){
    // TOTALXML+=`<MontoGravadoTotal>${  this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)  }</MontoGravadoTotal>`
    // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}
    
     TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed(((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3)-(TipoeCF==32 && cobertura>0?cobertura:0)),2).toFixed(2)}</MontoGravadoTotal>`
    //NOTA ESTO ES PARA CUENDO TIENE COBERTURA y ES E32 SABER CUANTO SE LE RESTARA DE COBERTURA A CADA una
    
    var DeCOB_MG=0,mtMG=(MontoGravadoI1+MontoGravadoI2+MontoGravadoI3); 
    // if(TipoeCF==32 && cobertura>0?cobertura:0){
    //   DeCOB_MG=(MontoGravado / TotalGravado) × DescuentoTotal
    // }

     if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed((MontoGravadoI1)-(TipoeCF==32 && cobertura>0?((MontoGravadoI1 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed((MontoGravadoI2)-(TipoeCF==32 && cobertura>0?((MontoGravadoI2 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed((MontoGravadoI3)-(TipoeCF==32 && cobertura>0?((MontoGravadoI3 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI3>`}
      TOTALXML+=`${MontoExento}`
      //-------------------------------------------------- 
    // if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    // if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    // if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}
    //-------------------------------------------------- 

    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2).toFixed(2)}</TotalITBIS>`

    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2).toFixed(2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2).toFixed(2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2).toFixed(2)}</TotalITBIS3>`}
  }else{

     /* MontoGravadoI1=(MontoGravadoI1-ITBIS18);
      MontoGravadoI2=(MontoGravadoI2-ITBIS16);
      MontoGravadoI3=(MontoGravadoI3-ITBIS0);*/

    //TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoTotal>`
   // if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoTotal-TotalItbis,2)}</MontoGravadoI1>`}


    var DeCOB_MG=0,mtMG=(MontoGravadoI1+MontoGravadoI2+MontoGravadoI3);

   TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed(((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3)-(TipoeCF==32 && cobertura>0?cobertura:0)),2).toFixed(2)}</MontoGravadoTotal>`
   
 
   if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed((MontoGravadoI1)-(TipoeCF==32 && cobertura>0?((MontoGravadoI1 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI1>`}
   if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed((MontoGravadoI2)-(TipoeCF==32 && cobertura>0?((MontoGravadoI2 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed((MontoGravadoI3)-(TipoeCF==32 && cobertura>0?((MontoGravadoI3 / mtMG) * cobertura):0),2).toFixed(2)}</MontoGravadoI3>`}
      TOTALXML+=`${MontoExento}`
    //-------------------------------------------------- 
    // if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    // if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    // if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}
    //---------------------------------------------------- 
    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2).toFixed(2)}</TotalITBIS>`
//  if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(TotalItbis,2)}</TotalITBIS1>`}
    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2).toFixed(2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2).toFixed(2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2).toFixed(2)}</TotalITBIS3>`}
  //MontoTotal= this.RedondeoValorCantRed((MontoTotal-FACTURA.valorimpuesto),2)
  
  }
}else{
  TOTALXML+=`${MontoExento}`
}

// TOTALXML+=`<MontoTotal>${FACTURA.valor}</MontoTotal>`

  var TOTAL=`
  <Totales>
       ${TOTALXML} 
      <MontoTotal>${MontoTotal}</MontoTotal>${MontoNoFacturable}${ValorPagar} 
    </Totales>
  `
return TOTAL;
},


getEmisorFactEletroRFCE(FACTURA){
//var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
//var SocialEmisor=this.$store.getters.GetConfiguracionGeneral.config.nombre.trim();
//var SocialEmisor=FACTURA.sucursal.descripcion.trim()
var SocialEmisor=FACTURA.sucursal.razonSocialDgi.trim()
var FechaEmision=this.FormatoFecha(FACTURA.nuevaFecha);
  var EMISOR=`
    <Emisor>
      <RNCEmisor>${RNCEmisor.replaceAll('&', '&amp;')}</RNCEmisor>
      <RazonSocialEmisor>${SocialEmisor.replaceAll('&', '&amp;')}</RazonSocialEmisor>
      <FechaEmision>${FechaEmision}</FechaEmision>
    </Emisor>`
    return EMISOR;

},



getTipoIngresos(TipoeCF){
var TipoIngresos='';
// ${this.getTipoIngresos(TipoeCF)}

if(TipoeCF===41){
  TipoIngresos='';
}else{
TipoIngresos='<TipoIngresos>01</TipoIngresos>';
}
return TipoIngresos;
},

getFormaDePagoFACTELECT(FACTURA){
  var MONEDAFACTURATASA=1
var SumaTotal = this.RedondeoBasico((FACTURA.efectivo +FACTURA.tarjeta + FACTURA.transferencia + FACTURA.cheques + FACTURA.cxc
        + FACTURA.cupones + FACTURA.valorConduce + FACTURA.valorNc)*MONEDAFACTURATASA)
var DEVUELTA=0
if(SumaTotal>FACTURA.valor){DEVUELTA=(SumaTotal-FACTURA.valor)}    

//formas de pago
/* a) Código Forma: 1: Efectivo 2: Cheque/Transferencia/Depósito 3: Tarjeta de Débito/Crédito 
4: Venta a Crédito 5: Bonos o Certificados de regalo 6: Permuta 7: Nota de crédito 8: Otras Formas de pago.
Si la forma de pago corresponde al tipo 
5 el e-CF debe ser tipo 32. */

var FormaDePago='';
if(FACTURA.hasOwnProperty('efectivo') && FACTURA.efectivo>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>1</FormaPago>
         <MontoPago>${(FACTURA.efectivo-DEVUELTA).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('cheques') && FACTURA.cheques>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>2</FormaPago>
         <MontoPago>${(FACTURA.cheques).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('transferencia') && FACTURA.transferencia>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>2</FormaPago>
         <MontoPago>${(FACTURA.transferencia).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('tarjeta') && FACTURA.tarjeta>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>3</FormaPago>
         <MontoPago>${(FACTURA.tarjeta).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('cxc') && FACTURA.cxc>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>4</FormaPago>
         <MontoPago>${(FACTURA.cxc).toFixed(2)}</MontoPago>
        </FormaDePago>`
}



// if(FACTURA.cxc>0){
//   FormaDePago+=`
//         <FormaDePago>
//          <FormaPago>4</FormaPago>
//          <MontoPago>${(FACTURA.cxc).toFixed(2)}</MontoPago>
//         </FormaDePago>`
// }

if(FACTURA.hasOwnProperty('valorNc') && FACTURA.valorNc>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>7</FormaPago>
         <MontoPago>${(FACTURA.valorNc).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('cupones') && FACTURA.cupones>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>5</FormaPago>
         <MontoPago>${(FACTURA.cupones).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('valorbonogas') && FACTURA.valorbonogas>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>5</FormaPago>
         <MontoPago>${(FACTURA.valorbonogas).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('valorasignacion') && FACTURA.valorasignacion>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>5</FormaPago>
         <MontoPago>${(FACTURA.valorasignacion).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('valordonacion') && FACTURA.valordonacion>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>5</FormaPago>
         <MontoPago>${(FACTURA.valordonacion).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('valorPruebaMetro') && FACTURA.valorPruebaMetro>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>8</FormaPago>
         <MontoPago>${(FACTURA.valorPruebaMetro).toFixed(2)}</MontoPago>
        </FormaDePago>`
}

if(FACTURA.hasOwnProperty('valorTraspaso') && FACTURA.valorTraspaso>0){
  FormaDePago+=`
        <FormaDePago>
         <FormaPago>8</FormaPago>
         <MontoPago>${(FACTURA.valorTraspaso).toFixed(2)}</MontoPago>
        </FormaDePago>`
} 

var TABLAFORMAPAGO=`
<TablaFormasPago>${FormaDePago}
</TablaFormasPago>
`

return FormaDePago.trim().length>0?TABLAFORMAPAGO:FormaDePago;
//return FormaDePago;
},


getDetallesItems(FACTURA){
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
   var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  
  // <IndicadorFacturacion>0</IndicadorFacturacion>
   //0: No Facturable 
  //1: ITBIS 1 (18%)  
  //2: ITBIS 2 (16%) 
  //3: ITBIS 3 (0%) 
  //4: Exento (E) 
  var ListDet=FACTURA.facturasventaDetalleList
  var VARDET=""
  var NumeroLinea=1


  // ListDet.forEach(element => { });
  Promise.all(ListDet.map(async (element) => {
    var IND_FACT=0

  //var MONTO_IMPUESTO=0;
  var MONTO_IMPUESTO=element.valorimpuesto;
  if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }
  if(TipoeCF==44){
    IND_FACT=4
  }

    

if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
 IND_FACT=4
}

if(TipoeCF==46){
    IND_FACT=3
  }

   var BienoServicio=element.productos.servicio==true?2:1
  var DESCUENTO=""
  if(element.valordescuento>0){
    DESCUENTO=`
    <DescuentoMonto>${this.RedondeoValorCantRed((element.valordescuento),2)}</DescuentoMonto> 
    <TablaSubDescuento>
      <SubDescuento>
        <TipoSubDescuento>$</TipoSubDescuento> 
        <MontoSubDescuento>${this.RedondeoValorCantRed((element.valordescuento),2)}</MontoSubDescuento> 
      </SubDescuento>
    </TablaSubDescuento>
   `
  }
  var precio=0;
if(IncluirItbisGeneral==false){
  precio=this.RedondeoValorCantRed(element.precio,2)
}else{
    // ESTo ERA 
  //var TASA = element.hasOwnProperty('impuesto') && element.impuesto!=null?(1+(element.impuesto.tasa/100)):1;
   // precio= this.RedondeoValorCantRed(element.precio/TASA,2)

//precio= this.RedondeoValorCantRed((element.precio-element.valorimpuesto),2)
//precio=element.precio

precio=this.RedondeoValorCantRed(element.precio,2)
}

  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
      <NombreItem>${element.descripcion.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>${BienoServicio}</IndicadorBienoServicio>
      <CantidadItem>${(this.RedondeoValorCantRed(element.cantidad,2)).toFixed(2)}</CantidadItem>
      <PrecioUnitarioItem>${precio.toFixed(2)}</PrecioUnitarioItem>
      ${DESCUENTO}
      <MontoItem>${(this.RedondeoValorCantRed(((element.cantidad*precio)-(element.valordescuento)),2)).toFixed(2)}</MontoItem> 
    </Item>`
    VARDET+=ITEM
  }));

  //       <UnidadReferencia>43</UnidadReferencia> 
  //       <CantidadReferencia>${element.cantidad}</CantidadReferencia>
return VARDET;

},


getDetallesItemsDevolucion(FACTURA){
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
  var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
   // <IndicadorFacturacion>0</IndicadorFacturacion>
   //0: No Facturable 
  //1: ITBIS 1 (18%)  
  //2: ITBIS 2 (16%) 
  //3: ITBIS 3 (0%) 
  //4: Exento (E) 
  var ListDet=FACTURA.ListDet
  var VARDET=""
  var NumeroLinea=1
  // ListDet.forEach(element => { });
  Promise.all(ListDet.map(async (element) => {
    var IND_FACT=0

  //var MONTO_IMPUESTO=0;
  var MONTO_IMPUESTO=element.valorimpuesto;
  if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }else{ IND_FACT=4 }

  if(TipoeCF==44){
    IND_FACT=4
  }

if(element.impuesto==null || element.impuesto!=null && !element.impuesto.hasOwnProperty("tasa")){ 
 IND_FACT=4
}

   var BienoServicio=element.productos.servicio==true?2:1
  var DESCUENTO=""
  if(element.valordescuento>0){
    DESCUENTO=`
    <DescuentoMonto>${this.RedondeoValorCantRed(element.valordescuento,2).toFixed(2)}</DescuentoMonto> 
    <TablaSubDescuento>
      <SubDescuento>
        <TipoSubDescuento>$</TipoSubDescuento> 
        <MontoSubDescuento>${this.RedondeoValorCantRed(element.valordescuento,2).toFixed(2)}</MontoSubDescuento> 
      </SubDescuento>
    </TablaSubDescuento>
   `
  }
var precio=0;
if(IncluirItbisGeneral==false){
  precio=this.RedondeoValorCantRed(element.precio,2)
}else{
  //var TASA = element.hasOwnProperty('impuesto') && element.impuesto!=null?(1+(element.impuesto.tasa/100)):1;
   // precio= this.RedondeoValorCantRed(element.precio/TASA,2)
//precio= this.RedondeoValorCantRed((element.precio-element.valorimpuesto),2)
//precio=element.precio
precio=this.RedondeoValorCantRed(element.precio,2)
}
if(FACTURA.quitaritbis==true){
  IND_FACT=4
if(IncluirItbisGeneral==true){
precio= this.RedondeoValorCantRed(element.precio-element.valorimpuesto,2)
}else{
precio= this.RedondeoValorCantRed(element.precio,2)
}

}
//if(FACTURA.valor==0){IND_FACT=0}
console.log(`<MontoItem>((((${element.cantidad*precio})-(${element.valordescuento})),2)).toFixed(2)</MontoItem>`)
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
      <NombreItem>${element.descripcion.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>${BienoServicio}</IndicadorBienoServicio>
      <CantidadItem>${(this.RedondeoValorCantRed(element.cantidad,2)).toFixed(2)}</CantidadItem>
      <PrecioUnitarioItem>${precio.toFixed(2)}</PrecioUnitarioItem>
      ${DESCUENTO}
      <MontoItem>${(this.RedondeoValorCantRed(((element.cantidad*precio)-(element.valordescuento)),2)).toFixed(2)}</MontoItem> 
    </Item>`
    VARDET+=ITEM
  }));

  //       <UnidadReferencia>43</UnidadReferencia> 
  //       <CantidadReferencia>${element.cantidad}</CantidadReferencia>
return VARDET;

},


//Recepción de resumen factura de consumo e-CF
FacturaXMLrFCE(FACTURA,codigoSeguridad){

var eNCF=FACTURA.ncf.trim()
var MontoTotal= FACTURA.valor;
var TotalItbis= FACTURA.valorimpuesto;
FACTURA.ListDet=FACTURA.facturasventaDetalleList
//var CodigoSeguridadeCF="130485" 
// El POS/coordinador pasa la firma del e-CF; conservar el editor XML manual antiguo.
var CodigoSeguridadeCF=codigoSeguridad==null?FACTURA.sucursal.codSeguridadDgi:codigoSeguridad
if (!CodigoSeguridadeCF || CodigoSeguridadeCF.length !== 6) throw new Error("Falta la firma del e-CF completo para preparar el resumen.")

// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
if(FACTURA.cxc>0){TipoPago=2}
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
if(FACTURA.valor==0){FACTURA.valorimpuesto=0}
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<RFCE>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>
      <eNCF>${eNCF}</eNCF>${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${this.getFormaDePagoFACTELECT(FACTURA)}
    </IdDoc> ${this.getEmisorFactEletroRFCE(FACTURA)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
    ${this.getTotalFactEletroRFCE(FACTURA)}
    <CodigoSeguridadeCF>${CodigoSeguridadeCF}</CodigoSeguridadeCF>
  </Encabezado>
</RFCE>`
// ${this.getTotalFactEletroECF(FACTURA)}

  return FAC_STRING.trim()
},



//Recepción de e‐CF: 
FacturaXMLeCF(FACTURA){ 
 //  abajo de <TipoPago>   , <FechaLimitePago>10-10-2024</FechaLimitePago> 
// 	 abajo de <IndicadorMontoGravado>  <IndicadorServicioTodoIncluido>1</IndicadorServicioTodoIncluido>
// console.log( new Date().toLocaleDateString("en-CA"))
// console.log(new Date())
// console.log(this.getHoraActual())

var eNCF=FACTURA.ncf.trim()
var MontoTotal= FACTURA.valor;
var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
FACTURA.ListDet=FACTURA.facturasventaDetalleList
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
//<FechaLimitePago> 
//<FechaLimitePago>${this.FormatoFecha(this.fechaNueva())}</FechaLimitePago>
/* <IndicadorEnvioDiferido>1</IndicadorEnvioDiferido> */
// <TotalPaginas>1</TotalPaginas>
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}${this.getFormaDePagoFACTELECT(FACTURA)}
    </IdDoc> ${this.getEmisorFactEletroECF(FACTURA)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
  	${ TipoeCF==46?this.getTotalFactEletroECF_TIPO46(FACTURA):this.getTotalFactEletroECF(FACTURA)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItems(FACTURA)}
  </DetallesItems>
  ${this.getDescuentoCobertura(FACTURA)}
  <FechaHoraFirma>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
//13-09-2024 17:11:44

/* <Paginacion>
    <Pagina>
      <PaginaNo>1</PaginaNo>
      <NoLineaDesde>1</NoLineaDesde>
      <NoLineaHasta>1</NoLineaHasta>
      <SubtotalMontoGravadoPagina>0.00</SubtotalMontoGravadoPagina>
      <SubtotalExentoPagina>0.00</SubtotalExentoPagina>
      <SubtotalItbisPagina>0.00</SubtotalItbisPagina>
	    <MontoSubtotalPagina>${MontoTotal}</MontoSubtotalPagina>
      <SubtotalMontoNoFacturablePagina>${MontoTotal}</SubtotalMontoNoFacturablePagina>
    </Pagina>
  </Paginacion> */

return FAC_STRING.trim();


},  

//Recepción de e‐CF: 
DevolucionXMLeCF(DEV,CODMOF){ 
var  FACTURA=JSON.parse(JSON.stringify(DEV.facturasventa))
var eNCF=DEV.ncf.trim()
var MontoTotal= DEV.valor;
// var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
//var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var TipoeCF= eNCF.substr(1,2)

var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var ahora=this.fechaNueva()
var DATA_FAC_DEV={
  ncfFac:FACTURA.ncf.trim(),
  sucursal:FACTURA.sucursal,
  nuevaFecha:DEV.nuevaFecha,
  nuevaFechaFac:FACTURA.nuevaFecha,
  valor:DEV.valor,
  valorimpuesto:DEV.valorItbis,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora),
  quitaritbis:DEV.hasOwnProperty('quitaritbis')&&DEV.quitaritbis!=null?DEV.quitaritbis:false
}

if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){
  DATA_FAC_DEV.cobertura=FACTURA.cobertura
  DATA_FAC_DEV.valor=(FACTURA.valor)
   // COBVALOR=FACTURA.cobertura
  }

var LIST_DEV=[]
 Promise.all(DEV.devolucionDetalleList.map(async (element) => { 
   var ObjProRow = DEV.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos.codigo == element.producto.codigo && ee.unidades.codigo == element.unidad.codigo && ee.precio == element.precio);
   ObjProRow[0].cantidad=element.cantidad
    ObjProRow[0].valordescuento=element.valordescuento
   LIST_DEV.push(ObjProRow[0])
  }));

// ${this.getIndicadorNotaCredito(ahora,FACTURA.nuevaFecha)}
DATA_FAC_DEV.ListDet=LIST_DEV
if(DATA_FAC_DEV.valor==0){DATA_FAC_DEV.valorimpuesto=0}
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF> ${this.getIndicadorNotaCredito(DATA_FAC_DEV.nuevaFecha,FACTURA.nuevaFecha)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_FAC_DEV)} ${this.getCompradorFactEletroECF_RFCE(FACTURA,TipoeCF)}
  	${ DATA_FAC_DEV.quitaritbis==true?this.getTotalFactDevNoItbisEletroECF(DATA_FAC_DEV):this.getTotalFactEletroECF(DATA_FAC_DEV)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsDevolucion(DATA_FAC_DEV)}
  </DetallesItems>${this.footerDevolucion(DATA_FAC_DEV,CODMOF)}
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
//13-09-2024 17:11:44

return FAC_STRING.trim();


},  

footerDevolucion(DATA_FAC_DEV,CODMOF){

//Código utilizado para indicar si el e-CF del comprobante fiscal modificado es con la finalidad de: 
/*1= a) Anulación total  
  2= b) Corrección montos  
  3= c) Corrección Texto  
  4= d) Reemplazo NCF emitido en contingencia 
  5= e) Referenciar Factura de Consumo Electrónica. 
 
  a), b) y c) solo aplican para Nota de 
  Crédito o Débito Electrónica.*/

  /*
  a) Código tipo80: 
1: Anula el NCF modificado 
2: Corrige Texto del Comprobante Fiscal modificado  
3: Corrige montos del NCF modificado 
4: Reemplazo NCF emitido en contingencia 
5: Referencia Factura Consumo Electrónica.81 
  */ 
//<RazonModificacion>Error en datos</RazonModificacion>
  var DEV_STRING=
  `<InformacionReferencia>
<NCFModificado>${DATA_FAC_DEV.ncfFac}</NCFModificado>
<FechaNCFModificado>${this.FormatoFecha(DATA_FAC_DEV.nuevaFechaFac)}</FechaNCFModificado>
<CodigoModificacion>${CODMOF}</CodigoModificacion>
</InformacionReferencia>
  `;

  return DEV_STRING;

},

// -*------------* NOTA DE DEBITO CXC *------------

async procesarTokenXML_ECF_NOTADEBITO_CXC(DAT,CODMOF){

  var FACTURA =JSON.parse(JSON.stringify(DAT.facturasventa))

 var Ahora= new Date()
  var expedido= FACTURA.sucursal.expedido
  var expira= FACTURA.sucursal.expira
  var token= FACTURA.sucursal.token


   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  // if(this.semilla!=null) 
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
      const resPROFAC_ECF =  await this.procesarNotadebitocliCxC_XML_ECF(DAT,resObjToken,CODMOF);
      return resPROFAC_ECF;
  }else{

   const resPROFAC_ECF =  await this.procesarNotadebitocliCxC_XML_ECF(DAT,SEMILLA,CODMOF);
    return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(FACTURA);
    const resPROFAC_ECF =  await this.procesarNotadebitocliCxC_XML_ECF(DAT,resObjToken,CODMOF);
    return resPROFAC_ECF;
  }


},

async procesarNotadebitocliCxC_XML_ECF(DAT,resObjToken,CODMOF){
   var FACT =JSON.parse(JSON.stringify(DAT.facturasventa))
 var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.notadebitocliCxC_XML_eCF(DAT,CODMOF);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+DAT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf!=null? FACT.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
var ObjCOMPLETO={};
//*  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 //var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  //ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
//* ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 //*ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 //ORIGINAL
 //ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DAT.ncf.trim()}&fechaemision=${this.FormatoFecha(DAT.nuevaFecha)}&montototal=${(DAT.valor+DAT.itbis).toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 
 const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DAT.ncf.trim()}&fechaemision=${this.FormatoFecha(DAT.nuevaFecha)}&montototal=${(DAT.valor+DAT.itbis).toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()

 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},

notadebitocliCxC_XML_eCF(DAT,CODMOF){
var  FACTURA=JSON.parse(JSON.stringify(DAT.facturasventa))
var eNCF=DAT.ncf.trim()
var MontoTotal= DAT.valor;
// var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
/*NOTA:TIPO DE PAGO
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>`
}*/
//var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var TipoeCF= eNCF.substr(1,2)
var fechaVencimiento=this.FormatoFecha(DAT.ncfVencimientonuevaFecha)
var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
//var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var IndicadorMontoGravado = 1;
var ahora=this.fechaNueva()
var DATA_FAC_DAT={
  ncfFac:FACTURA.ncf.trim(),
  sucursal:FACTURA.sucursal,
  nuevaFecha:DAT.nuevaFecha,
  nuevaFechaFac:FACTURA.nuevaFecha,
  valor:DAT.valor,
  valorimpuesto:DAT.itbis,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora),
  valorfact:FACTURA.valor
}

if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){
  DATA_FAC_DAT.cobertura=FACTURA.cobertura
  DATA_FAC_DAT.valor=(FACTURA.valor)
   // COBVALOR=FACTURA.cobertura
  }

var LIST_DEV=[]
 /*Promise.all(DAT.facturasventaDetalleList.map(async (element) => { 
   //var ObjProRow = DEV.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos.codigo == element.producto.codigo && ee.unidades.codigo == element.unidad.codigo && ee.precio == element.precio);
   //ObjProRow[0].cantidad=element.cantidad
   //LIST_DEV.push(ObjProRow[0])
  }));*/
DATA_FAC_DAT.ListDet=FACTURA.facturasventaDetalleList
// ${this.getFormaDePagoFACTELECT(FACTURA)}
//DATA_FAC_DAT.ListDet=LIST_DEV
var COMENT_NC= DAT.hasOwnProperty('concepto') && DAT.concepto!=null && DAT.concepto.trim().length>0? DAT.concepto :DAT.documentocxc.descripcion.trim()
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento)}${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
      <TablaFormasPago>
        <FormaDePago>
        <FormaPago>1</FormaPago>
        <MontoPago>${DATA_FAC_DAT.valor+DATA_FAC_DAT.valorimpuesto}</MontoPago>
        </FormaDePago>
      </TablaFormasPago>
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_FAC_DAT)} ${this.getCompradorFactEletroECF_RFCE(FACTURA)}
  	${this.getTotalnotaDebitocliCxC_EletroECF(DATA_FAC_DAT)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsNotadebitoCliCxC(DATA_FAC_DAT)}
  </DetallesItems>${this.footerNotacreditoclientes(DATA_FAC_DAT,CODMOF,COMENT_NC)}
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`


//return
//13-09-2024 17:11:44
return FAC_STRING.trim();

},

getTotalnotaDebitocliCxC_EletroECF(DATA_DAT){
var TOTAl_STRING=``

if(DATA_DAT.valorimpuesto!=null && DATA_DAT.valorimpuesto>0){
TOTAl_STRING=`
<Totales>
<MontoGravadoTotal>${DATA_DAT.valor}</MontoGravadoTotal>
<MontoGravadoI1>${DATA_DAT.valor}</MontoGravadoI1>
<ITBIS1>18</ITBIS1>
<TotalITBIS>${DATA_DAT.valorimpuesto}</TotalITBIS>
<TotalITBIS1>${DATA_DAT.valorimpuesto}</TotalITBIS1>
<MontoTotal>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoTotal>
</Totales>
`

}else{

TOTAl_STRING=`
<Totales>
<MontoExento>${DATA_DAT.valor}</MontoExento>
<MontoTotal>${DATA_DAT.valor}</MontoTotal>
</Totales>`

}

  return TOTAl_STRING
},
getDetallesItemsNotadebitoCliCxC(DATA_DAT){
  
  var IND_FACT=4
  if(DATA_DAT.valorimpuesto>0){IND_FACT=1}
var ITEM_STRING=`
<Item>
<NumeroLinea>1</NumeroLinea>
<IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
<NombreItem>Ajuste por diferencia de precio (ND)</NombreItem>
<IndicadorBienoServicio>1</IndicadorBienoServicio>
<CantidadItem>1</CantidadItem>
<UnidadMedida>43</UnidadMedida>
<PrecioUnitarioItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</PrecioUnitarioItem>
<MontoItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoItem>
</Item>`

/*var ITEM_STRING=`
<Item>
      <NumeroLinea>1</NumeroLinea>
      <NombreItem>Ajuste por diferencia de precio (ND)</NombreItem>
      <Cantidad>1</Cantidad>
      <PrecioUnitario>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</PrecioUnitario>
      <MontoItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoItem>
    </Item>`*/
return ITEM_STRING;

},


// -*------------* FIN NOTA DE DEBITO CXC *------------

// -*------------* NOTA DE CREDITO *------------


async procesarTokenXML_ECF_NOTACREDITO(DAT,CODMOF,control){
  // Primero firma y persiste localmente; autenticar ante DGII corresponde al servidor.
  return this.procesarNotacreditoclientesXML_ECF(DAT,{},CODMOF,control);
},

async procesarNotacreditoclientesXML_ECF(DAT,resObjToken,CODMOF,control){
   var FACT =JSON.parse(JSON.stringify(DAT.facturasventa))
 var ObjDirecSucursal={
nombreCertDGI:FACT.caja!=null?FACT.caja.sucursal.nombreArchivoDgi:FACT.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja!=null?FACT.caja.sucursal.passCertDgi:FACT.sucursal.passCertDgi,
sucursalRnc:FACT.caja!=null?FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,''):FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.notacreditoclientesXMLeCF(DAT,CODMOF);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+DAT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf!=null? FACT.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
var ObjCOMPLETO={};
 //*  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 //var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  //ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 //*  ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 //*ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 //ORIGINAL
 //ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DAT.ncf.trim()}&fechaemision=${this.FormatoFecha(DAT.nuevaFecha)}&montototal=${DAT.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 
 const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DAT.ncf.trim()}&fechaemision=${this.FormatoFecha(DAT.nuevaFecha)}&montototal=${DAT.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 ObjCOMPLETO.usarCola = true;
 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal,control)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},

notacreditoclientesXMLeCF(DAT,CODMOF){
var  FACTURA=JSON.parse(JSON.stringify(DAT.facturasventa))
var eNCF=DAT.ncf.trim()
var MontoTotal= DAT.valor.toFixed(2);
// var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(FACTURA.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
//var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var TipoeCF= eNCF.substr(1,2)

var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var ahora=this.fechaNueva()
var DATA_FAC_DAT={
  ncfFac:FACTURA.ncf.trim(),
  sucursal:FACTURA.sucursal,
  nuevaFecha:DAT.nuevaFecha,
  nuevaFechaFac:FACTURA.nuevaFecha,
  valor:DAT.valor.toFixed(2),
  valorimpuesto:DAT.valorItbis,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora),
  valorNotPen:(DAT.pendiente),
  valorfact:FACTURA.valor.toFixed(2)
}

if(FACTURA.hasOwnProperty('cobertura')&& FACTURA.cobertura!=null && FACTURA.cobertura>0){
  DATA_FAC_DAT.cobertura=FACTURA.cobertura
  DATA_FAC_DAT.valor=(FACTURA.valor)
   // COBVALOR=FACTURA.cobertura
  }

var LIST_DEV=[]
 /*Promise.all(DAT.facturasventaDetalleList.map(async (element) => { 
   //var ObjProRow = DEV.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos.codigo == element.producto.codigo && ee.unidades.codigo == element.unidad.codigo && ee.precio == element.precio);
   //ObjProRow[0].cantidad=element.cantidad
   //LIST_DEV.push(ObjProRow[0])
  }));*/
DATA_FAC_DAT.ListDet=FACTURA.facturasventaDetalleList
// ${this.getIndicadorNotaCredito(ahora,FACTURA.nuevaFecha)}
//DATA_FAC_DAT.ListDet=LIST_DEV
var COMENT_NC= DAT.hasOwnProperty('concepto') && DAT.concepto!=null && DAT.concepto.trim().length>0? DAT.concepto :DAT.documentocxc.descripcion.trim()
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF> ${this.getIndicadorNotaCredito(DATA_FAC_DAT.nuevaFecha,FACTURA.nuevaFecha)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} ${this.getTipoIngresos(TipoeCF)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_FAC_DAT)} ${this.getCompradorFactEletroECF_RFCE(FACTURA,TipoeCF)}
  	${this.getTotalnotacreditoclientesEletroECF(DATA_FAC_DAT, DAT.valor.toFixed(2))}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsNotacreditoclientes(DATA_FAC_DAT,DAT.valor,DAT.documentocxc.descripcion.trim())}
  </DetallesItems>${this.footerNotacreditoclientes(DATA_FAC_DAT,CODMOF,COMENT_NC)}
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`


//return
//13-09-2024 17:11:44
return FAC_STRING.trim();

},

getTotalnotacreditoclientesEletroECF(FACTURA,VALOR_NC){
  var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
  var MontoTotal=VALOR_NC
  var TOTALXML=''
  var MontoExento='';


  var MONTO_GENERAL=0
MONTO_GENERAL=FACTURA.valorfact;
var ListDetCOB=JSON.parse(JSON.stringify(FACTURA.ListDet))


var VALOR_DESC_NC18=0
var VALOR_DESC_NC16=0
var VALOR_DESC_NC0=0
var VALOR_DESC_NCExento=0

 Promise.all(ListDetCOB.map(async (element) => {
  var IND_FACT=0
    if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }else{
    IND_FACT=4
  }

 // var VALOR_DESC=(((element.cantidad*element.precio) /MONTO_GENERAL)*VALOR_NC)
 var VALOR_DESC=0
if(IncluirItbisGeneral==true){
VALOR_DESC=(((element.cantidad*element.precio) /MONTO_GENERAL)*VALOR_NC)

}else{
  VALOR_DESC=((((element.cantidad*element.precio)+(element.cantidad*element.valorimpuesto)) /MONTO_GENERAL)*VALOR_NC)
}
    if(IND_FACT==1){VALOR_DESC_NC18+=(VALOR_DESC)}
    if(IND_FACT==2){VALOR_DESC_NC16+=(VALOR_DESC)}
    if(IND_FACT==3){VALOR_DESC_NC0+=(VALOR_DESC)}
    if(IND_FACT==4){VALOR_DESC_NCExento+=(VALOR_DESC)}
    }));



if(VALOR_DESC_NCExento>0){
MontoExento=`
      <MontoExento>${(VALOR_DESC_NCExento).toFixed(2)}</MontoExento>
      `
}



 var MontoGravadoI1=0.00;
 var MontoGravadoI2=0.00;
 var MontoGravadoI3=0.00;
 var ITBIS18=0.00;
 var ITBIS16=0.00; 
  var ITBIS0=0.00;
if(VALOR_DESC_NC18>0){
 
ITBIS18=(VALOR_DESC_NC18*0.18)
MontoGravadoI1=(VALOR_DESC_NC18-ITBIS18)

//  if(IncluirItbisGeneral==true){  
//  }
 
}

if(VALOR_DESC_NC16>0){ 
  ITBIS16=(VALOR_DESC_NC16*0.16)
MontoGravadoI2=(VALOR_DESC_NC16-ITBIS16)
//if(IncluirItbisGeneral==true){ }
}

if(VALOR_DESC_NC0>0){ 
 ITBIS0=(VALOR_DESC_NC0*0.0)
  MontoGravadoI3=(VALOR_DESC_NC0-ITBIS0)
 //if(IncluirItbisGeneral==true){}
}

TOTALXML+=`<MontoGravadoTotal>${this.RedondeoValorCantRed((MontoGravadoI1+MontoGravadoI2+MontoGravadoI3),2).toFixed(2)}</MontoGravadoTotal>`
     if(ITBIS18>0){TOTALXML+=`<MontoGravadoI1>${this.RedondeoValorCantRed(MontoGravadoI1,2).toFixed(2)}</MontoGravadoI1>`}
    if(ITBIS16>0){TOTALXML+=`<MontoGravadoI2>${this.RedondeoValorCantRed(MontoGravadoI2,2).toFixed(2)}</MontoGravadoI2>`}
    if(ITBIS0>0){TOTALXML+=`<MontoGravadoI3>${this.RedondeoValorCantRed(MontoGravadoI3,2).toFixed(2)}</MontoGravadoI3>`}
       TOTALXML+=`${MontoExento}`
    if(ITBIS18>0){TOTALXML+=`<ITBIS1>18</ITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<ITBIS2>16</ITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<ITBIS3>0</ITBIS3>`}

    TOTALXML+=`<TotalITBIS>${this.RedondeoValorCantRed(ITBIS18+ITBIS16+ITBIS0,2).toFixed(2)}</TotalITBIS>`

    if(ITBIS18>0){TOTALXML+=`<TotalITBIS1>${this.RedondeoValorCantRed(ITBIS18,2).toFixed(2)}</TotalITBIS1>`}
    if(ITBIS16>0){TOTALXML+=`<TotalITBIS2>${this.RedondeoValorCantRed(ITBIS16,2).toFixed(2)}</TotalITBIS2>`}
    if(ITBIS0>0){TOTALXML+=`<TotalITBIS3>${this.RedondeoValorCantRed(ITBIS0,2).toFixed(2)}</TotalITBIS3>`}


     var TOTAL=`
  <Totales>
       ${TOTALXML} 
      <MontoTotal>${MontoTotal>0?MontoTotal:`0.00`}</MontoTotal> 
    </Totales>
  `
  return TOTAL;
},

getDetallesItemsNotacreditoclientes(FACTURA,VALOR_NC,NOMB_ITEMS){
var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;  
var MONTO_GENERAL=0
MONTO_GENERAL=FACTURA.valorfact;
var ListDetCOB=JSON.parse(JSON.stringify(FACTURA.ListDet))

var VALOR_DESC_NC18=0
var VALOR_DESC_NC16=0
var VALOR_DESC_NC0=0
var VALOR_DESC_NCExento=0

 Promise.all(ListDetCOB.map(async (element) => {
       var IND_FACT=0
    if(element.valorimpuesto>0 &&element.impuesto!=null && element.impuesto.hasOwnProperty("tasa")){
    if(element.impuesto.tasa==18){IND_FACT=1}
    if(element.impuesto.tasa==16){IND_FACT=2}
    if(element.impuesto.tasa==0){IND_FACT=3}
  }else{
    IND_FACT=4
  }
 
var VALOR_DESC=0
if(IncluirItbisGeneral==true){
VALOR_DESC=(((element.cantidad*element.precio) /MONTO_GENERAL)*VALOR_NC)

}else{
  VALOR_DESC=((((element.cantidad*element.precio)+(element.cantidad*element.valorimpuesto)) /MONTO_GENERAL)*VALOR_NC)
}


  // console.log(`-PROPORCION:-> ((${element.cantidad}*${element.precio}) / ${MONTO_GENERAL})`)
   // console.log(`(${VALOR_NC} * ${PROPORCION})`)
  // console.log(`((${element.cantidad}*${element.precio}) - ${ADESCONTAR})`)
  
    if(IND_FACT==1){VALOR_DESC_NC18+=(VALOR_DESC)}
    if(IND_FACT==2){VALOR_DESC_NC16+=(VALOR_DESC)}
    if(IND_FACT==3){VALOR_DESC_NC0+=(VALOR_DESC)}
    if(IND_FACT==4){VALOR_DESC_NCExento+=(VALOR_DESC)}
    }));

  var VARDET=""
  var NumeroLinea=1 
if(VALOR_DESC_NC18>0){
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>1</IndicadorFacturacion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC18,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC18,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
}
if(VALOR_DESC_NC16>0){ 
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>2</IndicadorFacturacion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC16,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC16,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM

}

if(VALOR_DESC_NC0>0){ 
  var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>3</IndicadorFacturacion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC0,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(VALOR_DESC_NC0,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM

}

if(VALOR_DESC_NCExento>0){ 
 var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>4</IndicadorFacturacion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(VALOR_DESC_NCExento,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(VALOR_DESC_NCExento,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
}

return VARDET;

},

footerNotacreditoclientes(DATA_FAC_DEV,CODMOF,RAZON_MODIF){

//Código utilizado para indicar si el e-CF del comprobante fiscal modificado es con la finalidad de: 
/*1= a) Anulación total  
  2= b) Corrección montos  
  3= c) Corrección Texto  
  4= d) Reemplazo NCF emitido en contingencia 
  5= e) Referenciar Factura de Consumo Electrónica. 
 
  a), b) y c) solo aplican para Nota de 
  Crédito o Débito Electrónica.*/

  /*
  a) Código tipo80: 
1: Anula el NCF modificado 
2: Corrige Texto del Comprobante Fiscal modificado  
3: Corrige montos del NCF modificado 
4: Reemplazo NCF emitido en contingencia 
5: Referencia Factura Consumo Electrónica.81 
  */ 
//<RazonModificacion>Error en datos</RazonModificacion>
  var DEV_STRING=
  `<InformacionReferencia>
<NCFModificado>${DATA_FAC_DEV.ncfFac}</NCFModificado>
<FechaNCFModificado>${this.FormatoFecha(DATA_FAC_DEV.nuevaFechaFac)}</FechaNCFModificado>
<CodigoModificacion>${CODMOF}</CodigoModificacion>
<RazonModificacion>${RAZON_MODIF.trim().replaceAll('&', '&amp;').substr(0,79)}</RazonModificacion>
</InformacionReferencia>
  `;

  
  return DEV_STRING;

},

// -*------------* FIN NOTA DE CREDITO *------------


getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado){
var IND_MON_GRAV=``;

var TIPO_ECF_ARRYS=[33,34,43,44,46,47]
if(TIPO_ECF_ARRYS.includes(TipoeCF)){
  IND_MON_GRAV=``;
}else{

  if(TipoeCF==41){
IND_MON_GRAV=`
<IndicadorMontoGravado>0</IndicadorMontoGravado>`

  }else{
IND_MON_GRAV=`
<IndicadorMontoGravado>${IndicadorMontoGravado}</IndicadorMontoGravado>`

  }
 
}

return IND_MON_GRAV;
},


getIndicadorNotaCredito(FechAhora,factnuevaFecha){

// var Ahora= new Date();
// var NEW_EXPIRA =new Date(res.data.fechaSupencion)

const fechaFact = new Date(factnuevaFecha);
const Ahora = new Date(FechAhora);
// Calcular la diferencia en milisegundos
const diferenciaMs = Ahora - fechaFact;
// Convertir a días
const diasPasados = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

//a) Valor 0 si fecha de emisión del e-CF afectado es ≤ 30 días calendario.  
//b) Valor 1 si fecha de emisión del e-CF afectado es > 30 días calendario. 

var IND_NOT_CRE=``;
var DAT_NOT_CRE= diasPasados>30?1:0;
IND_NOT_CRE=`
<IndicadorNotaCredito>${DAT_NOT_CRE}</IndicadorNotaCredito>`
return IND_NOT_CRE;
},

getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento){
var FEC_VEN_SEC=``;


if(TipoeCF===32 || TipoeCF===34){
}else{
  FEC_VEN_SEC=`
<FechaVencimientoSecuencia>${fechaVencimiento}</FechaVencimientoSecuencia>`
}

return FEC_VEN_SEC;
},

//Recepción de resumen factura de consumo e-CF
AnularFacturaXML(FACTURA){

var eNCF=FACTURA.ncf.trim()
var CodigoSeguridadeCF="130485"
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';


// var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var RNCEmisor =FACTURA.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';

var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ANECF>
  <Encabezado>
    <Version>1.0</Version>
    <RncEmisor>${RNCEmisor}</RncEmisor>
    <CantidadeNCFAnulados>1</CantidadeNCFAnulados>
    <FechaHoraAnulacioneNCF>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraAnulacioneNCF>
  </Encabezado>
  <DetalleAnulacion> 
    <Anulacion>
     <NoLinea>1</NoLinea>
     <TipoeCF>${TipoeCF}</TipoeCF>
      <Secuencias> 
       <SecuenciaeNCFDesde>${eNCF}</SecuenciaeNCFDesde>
       <SecuenciaeNCFHasta>${eNCF}</SecuenciaeNCFHasta>
      </Secuencias>
      <CantidadeNCFAnulados>1<CantidadeNCFAnulados>
    </Anulacion>
  </DetalleAnulacion>
</ANECF>`
  return FAC_STRING.trim()
},

async procesarTokenXML_RFCE(FACTURA,control){
  // Primero firma y persiste localmente; autenticar ante DGII corresponde al servidor.
  return this.procesarFacturaXML_RFCE(FACTURA,{},control);
},

async procesarFacturaXML_RFCE(FACT,resObjToken,control){

  var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
  const xmlCompleto = await this.firmarArchivoXML(await this.FacturaXMLeCF(FACT),ObjDirecSucursal);
  const firmaCompleta = xmlCompleto.match(/<SignatureValue[^>]*>([\s\S]*?)<\/SignatureValue>/);
  if (!firmaCompleta || firmaCompleta[1].replace(/\s/g, "").length < 6) throw new Error("No se obtuvo la firma del e-CF completo.");
  const codigoSeguridad = firmaCompleta[1].replace(/\s/g, "").substring(0, 6);
  const fechaCompleta = xmlCompleto.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  if (!fechaCompleta) throw new Error("Falta la fecha de firma del e-CF completo.");
  const resXMLConvert = await this.FacturaXMLrFCE(FACT,codigoSeguridad);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;

  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf= FACT.cedularncncf!=null?FACT.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";

  //const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));


  var ObjCOMPLETO={};
  ObjCOMPLETO.codSeguridadDgi=codigoSeguridad;
  ObjCOMPLETO.xmlCompleto=xmlCompleto;
  fechafirmadgii=fechaCompleta[1];
  // E320000031086--> https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=130412881&encf=E320000031086&montototal=727.12&codigoseguridad=130485

  // `https://fc.dgii.gov.do/${AMBIENTE}/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${FACT.ncf.trim()}&montototal=${FACT.valor}&codigoseguridad=${ObjCOMPLETO.codSeguridadDgi}`
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
  ObjCOMPLETO.qrdgii=`https://fc.dgii.gov.do/${AMBIENTE}/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${FACT.ncf.trim()}&montototal=${FACT.valor.toFixed(2)}&codigoseguridad=${encodeURIComponent(codigoSeguridad)}`
  
  ObjCOMPLETO.signatureValue=codigoSeguridad
  ObjCOMPLETO.ObjToken=resObjToken;
  ObjCOMPLETO.xmlSellada=resXMLSellada
  ObjCOMPLETO.nombreXml=NombreXml
  ObjCOMPLETO.ambiente=AMBIENTE

  ObjCOMPLETO.usarCola = true;
 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal,control)
 // this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


  //  https://fc.dgii.gov.do/{ambiente}/recepcionfc/api/recepcion/ecf
// COMiENSO AQUI
  //   return  new Promise((resolve, reject) => {  
//     //var AMBIENTE='testecf'
//     // var AMBIENTE= this.ambiente
//     var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
//     let texto = resXMLSellada
//   let blob = new Blob([texto], { type: 'application/xml' });
//   const formData = new FormData();  
//   formData.append('xml', blob, `${NombreXml}.xml`);      
//         var headHEAD={} ;
//          headHEAD["Content-Type"] = "multipart/form-data"
//          headHEAD["accept"]= "application/json"
//          headHEAD["Authorization"]= "Bearer "+TOKEN
//         headHEAD["Accept-Encoding"] = "gzip, deflate, br, zstd"
//         headHEAD["Access-Control-Allow-Origin"] = "*"
//         headHEAD["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,PATCH,OPTIONS"
//         headHEAD["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, Authorization"
//         headHEAD["Access-Control-Allow-Origin"] = "https://localhost:8080"


// // 'Access-Control-Allow-Origin' : '*',
// //   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',


//   /*headers.append('Content-Type', 'application/json');
//   headers.append('Accept', 'application/json');

//   headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
//   headers.append('Access-Control-Allow-Credentials', 'true');

//   headers.append('GET', 'POST', 'OPTIONS');*/


//         // var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
//         var url2=`https://fc.dgii.gov.do/${AMBIENTE}/recepcionfc/api/recepcion/ecf`
//           this.$axios.post(url2,formData,{ headers: headHEAD })
//         .then((resss) => {
//           console.log('resss-->',resss.data)
//           resolve(resss.data)
//          })
//          .catch((error) => {
//           this.alerta("DATA XML NO VALIDADO", "error")
//           resolve(null)
//         });

//   });
// FIn AQUI







/*const resXMLConvert = this.FacturaXMLeCF(ObjFAC);
const resXMLSellada = await this.firmarArchivoXML(resXMLConvert);
const reader = new FileReader();
var xmlString=''; 
var _this = this;*/

},

async procesarTokenXML_ECF(FACTURA,control){
  // Primero firma y persiste localmente; autenticar ante DGII corresponde al servidor.
  return this.procesarFacturaXML_ECF(FACTURA,{},control);
},

async procesarFacturaXML_ECF(FACT,resObjToken,control){
   
/*var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }*/

var DA_SUCURSAL= FACT.caja!=null?FACT.caja.sucursal:FACT.sucursal
var ObjDirecSucursal={
nombreCertDGI:DA_SUCURSAL.nombreArchivoDgi,
passCertDGI:DA_SUCURSAL.passCertDgi,
sucursalRnc:DA_SUCURSAL.rnc.trim().replace("-", "").replace(/-/g,'')
 }

  

 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.FacturaXMLeCF(FACT);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf!=null? FACT.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  //console.log("resXMLSellada-Asig->",resXMLSellada)
  //console.log("resXMLSellada-Asig-2->",resXMLSellada.split("<SignatureValue>"))

  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));

var ObjCOMPLETO={};
//  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 //var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
 // ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()

//** ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;

//original
//ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${FACT.ncf.trim()}&fechaemision=${this.FormatoFecha(FACT.nuevaFecha)}&montototal=${FACT.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 
 /**/const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
 ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${FACT.ncf.trim()}&fechaemision=${this.FormatoFecha(FACT.nuevaFecha)}&montototal=${FACT.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE
 ObjCOMPLETO.usarCola = true;
 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal,control)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


//  https://fc.dgii.gov.do/{ambiente}/recepcionfc/api/recepcion/ecf
  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   
    let texto = resXMLSellada
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, `${NombreXml}.xml`);      
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         headHEAD["Authorization"]= "Bearer "+resObjToken.token
        headHEAD["Accept-Encoding"] = "gzip, deflate, br, zstd"
        headHEAD["Access-Control-Allow-Origin"] = "*"
        headHEAD["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,PATCH,OPTIONS"
        headHEAD["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, Authorization"
        headHEAD["Access-Control-Allow-Origin"] = "https://localhost:8080"


// 'Access-Control-Allow-Origin' : '*',
//   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  /*headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
  headers.append('Access-Control-Allow-Credentials', 'true');
  headers.append('GET', 'POST', 'OPTIONS');*/
        // var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
        // var url2=`https://fc.dgii.gov.do/${AMBIENTE}/recepcionfc/api/recepcion/ecf`
        
        var url2=`https://ecf.dgii.gov.do/${ambiente}/recepcion/api/facturaselectronicas`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          console.log('resss-->',resss.data)
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });


},

// -*------------* DEVOLUCION *------------

async procesarTokenXML_ECF_DEV(DEV,CODMOF,control){
  // Primero firma y persiste localmente; autenticar ante DGII corresponde al servidor.
  return this.procesarDevolucionXML_ECF(DEV,{},CODMOF,control);
},

async procesarDevolucionXML_ECF(DEV,resObjToken,CODMOF,control){
   var FACT =JSON.parse(JSON.stringify(DEV.facturasventa))
 var ObjDirecSucursal={
nombreCertDGI:FACT.caja.sucursal.nombreArchivoDgi,
passCertDGI:FACT.caja.sucursal.passCertDgi,
sucursalRnc:FACT.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=FACT.sucursal.ambienteDgi!=null?FACT.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.DevolucionXMLeCF(DEV,CODMOF);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+DEV.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.cedularncncf!=null? FACT.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
var ObjCOMPLETO={};
//  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 //var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  //ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
//*  ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 //*ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 //original
 //ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 
 const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 ObjCOMPLETO.usarCola = true;
 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal,control)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},


// -*------------* FIN DEVOLUCION *------------

// -*------------* GASTOS MENORES *------------

async procesarTokenXML_ECF_GASTOSMENORES(GASTOS){

var GASTO_DATA=JSON.parse(JSON.stringify(GASTOS))
GASTO_DATA.caja={sucursal:GASTOS.sucursal}
  

 var Ahora= new Date()
  var expedido= GASTOS.sucursal.expedido
  var expira= GASTOS.sucursal.expira
  var token= GASTOS.sucursal.token

   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  //  if(this.semilla!=null)
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
      const resPROFAC_RFCE =  await this.procesarFacturaXML_ECF_GASTOSMENORES(GASTO_DATA,resObjToken);
      return resPROFAC_RFCE;
  }else{
    const resPROFAC_RFCE =  await this.procesarFacturaXML_ECF_GASTOSMENORES(GASTO_DATA,SEMILLA);
     return resPROFAC_RFCE;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
    const resPROFAC_RFCE =  await this.procesarFacturaXML_ECF_GASTOSMENORES(GASTO_DATA,resObjToken);
    return resPROFAC_RFCE;
  }

},

async procesarFacturaXML_ECF_GASTOSMENORES(GASTOS,resObjToken){
  var ObjDirecSucursal={
nombreCertDGI:GASTOS.caja.sucursal.nombreArchivoDgi,
passCertDGI:GASTOS.caja.sucursal.passCertDgi,
sucursalRnc:GASTOS.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  var AMBIENTE=GASTOS.sucursal.ambienteDgi!=null?GASTOS.sucursal.ambienteDgi:"testecf";
  const resXMLConvert = await this.GastoMenoresXMLeCF(GASTOS);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;

  var RNCEmisor =GASTOS.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+GASTOS.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
 const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));


  var ObjCOMPLETO={};
  ObjCOMPLETO.codSeguridadDgi=GASTOS.sucursal.codSeguridadDgi.trim()

  /* original
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&encf=${GASTOS.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTOS.nuevaFecha)}&montototal=${GASTOS.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  */
  
  const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&encf=${GASTOS.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTOS.nuevaFecha)}&montototal=${GASTOS.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
  ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
  ObjCOMPLETO.ObjToken=resObjToken;
  ObjCOMPLETO.xmlSellada=resXMLSellada
  ObjCOMPLETO.nombreXml=NombreXml
  ObjCOMPLETO.ambiente=AMBIENTE
  const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


},

//Recepción de resumen factura de consumo e-CF
GastoMenoresXMLeCF(GASTOS){
var eNCF=GASTOS.ncf.trim()
var MontoTotal= GASTOS.valor;
var TotalItbis= GASTOS.valorimpuesto;
var fechaVencimiento=this.FormatoFecha(GASTOS.ncfVencimientonuevaFecha)
//GASTOS.ListDet=GASTOS.facturasventaDetalleList

//var CodigoSeguridadeCF="130485" 
var CodigoSeguridadeCF=GASTOS.sucursal.codSeguridadDgi

// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  


var TipoeCF= GASTOS.tipocomprobante.hasOwnProperty('tipoEcf') && GASTOS.tipocomprobante.tipoEcf!=null?GASTOS.tipocomprobante.tipoEcf:'';
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento)}
    </IdDoc> ${this.getEmisorFactEletroECF(GASTOS)}
     <Totales>
      <MontoExento>${this.RedondeoValorCantRed(GASTOS.valor,2).toFixed(2)}</MontoExento>
      <MontoTotal>${this.RedondeoValorCantRed(GASTOS.valor,2).toFixed(2)}</MontoTotal>
    </Totales>
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsGastoMenores(GASTOS.ListDet)}
  </DetallesItems>
  <FechaHoraFirma>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
// ${this.getTotalFactEletroECF(FACTURA)}

  return FAC_STRING.trim()
},

getDetallesItemsGastoMenores(GASTOS){

   var VARDET=""
  var NumeroLinea=1
  var IND_FACT=4
  var BienoServicio=2
  var cantidad=1
 Promise.all(GASTOS.map(async (element) => {
  // <CantidadItem>${cantidad}</CantidadItem>
   //<UnidadMedida>43</UnidadMedida>
   //let texto = valor.toString();
   //(this.RedondeoValorCantRed(cantidad,2)).toFixed(2)
   var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
      <NombreItem>${element.descripcion.trim().substr(0,79).replace(/\s+/g, ' ').replaceAll('&', '&amp;')}</NombreItem>
      <IndicadorBienoServicio>${BienoServicio}</IndicadorBienoServicio>
      <CantidadItem>${(this.RedondeoValorCantRed(cantidad,2)).toFixed(2)}</CantidadItem>
      <PrecioUnitarioItem>${ this.RedondeoValorCantRed(element.valor,2).toFixed(2) }</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed((element.valor),2).toFixed(2))}</MontoItem> 
    </Item>`
    VARDET+=ITEM
  }));
return VARDET;
},

// -*------------* FIN GASTOS MENORES *------------

// -*------------* GASTOS PROVEEDORES INFORMALES *------------
async procesarTokenXML_ECF_GASTOS_PROINF(GASTOS){

var GASTO_DATA=JSON.parse(JSON.stringify(GASTOS))
GASTO_DATA.caja={sucursal:GASTOS.sucursal}
  

 var Ahora= new Date()
  var expedido= GASTOS.sucursal.expedido
  var expira= GASTOS.sucursal.expira
  var token= GASTOS.sucursal.token

   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  //  if(this.semilla!=null)
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
      const resPROFAC_ECF =  await this.procesarFacturaXML_ECF_GASTOS_PROINF(GASTO_DATA,resObjToken);
      return resPROFAC_ECF;
  }else{
    const resPROFAC_ECF =  await this.procesarFacturaXML_ECF_GASTOS_PROINF(GASTO_DATA,SEMILLA);
     return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
    const resPROFAC_ECF =  await this.procesarFacturaXML_ECF_GASTOS_PROINF(GASTO_DATA,resObjToken);
    return resPROFAC_ECF;
  }

},

async procesarFacturaXML_ECF_GASTOS_PROINF(GASTOS,resObjToken){ 
var ObjDirecSucursal={
nombreCertDGI:GASTOS.caja.sucursal.nombreArchivoDgi,
passCertDGI:GASTOS.caja.sucursal.passCertDgi,
sucursalRnc:GASTOS.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
  var AMBIENTE=GASTOS.sucursal.ambienteDgi!=null?GASTOS.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.GastoPROINF_XMLeCF(GASTOS);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;

  var RNCEmisor =GASTOS.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');

  var cedularncncf=GASTOS.dgastos.proveedor.rnc!=null? GASTOS.dgastos.proveedor.rnc.trim().replace("-", "").replace(/-/g,''):"";
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
  var NombreXml=RNCEmisor.trim()+""+GASTOS.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
 const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));


  var ObjCOMPLETO={};
  ObjCOMPLETO.codSeguridadDgi=GASTOS.sucursal.codSeguridadDgi.trim()

  /*ORIGINAL
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${GASTOS.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTOS.nuevaFecha)}&montototal=${GASTOS.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  */
  const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${GASTOS.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTOS.nuevaFecha)}&montototal=${GASTOS.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
  
  ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
  ObjCOMPLETO.ObjToken=resObjToken;
  ObjCOMPLETO.xmlSellada=resXMLSellada
  ObjCOMPLETO.nombreXml=NombreXml
  ObjCOMPLETO.ambiente=AMBIENTE
  const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal)
 //this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO


},

async GastoPROINF_XMLeCF(GASTOS){
var eNCF=GASTOS.ncf.trim()
var MontoTotal= GASTOS.valor;
var TotalItbis= GASTOS.valorimpuesto;
var fechaVencimiento=this.FormatoFecha(GASTOS.ncfVencimientonuevaFecha)
//var CodigoSeguridadeCF="130485" 
var CodigoSeguridadeCF=GASTOS.sucursal.codSeguridadDgi

var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0

var TipoeCF= GASTOS.tipocomprobante.hasOwnProperty('tipoEcf') && GASTOS.tipocomprobante.tipoEcf!=null?GASTOS.tipocomprobante.tipoEcf:'';

var SocialComprador= GASTOS.dgastos.proveedor==null || GASTOS.dgastos.proveedor.nombre.trim().length==0?'CONTADO':GASTOS.dgastos.proveedor.nombre.trim().toUpperCase();
var RNCComprador= GASTOS.dgastos.rnc!=null? GASTOS.dgastos.rnc.trim().replace("-", "").replace(/-/g,''):"";
var TipoPago = GASTOS.dgastos.formaPago==4 ? 2 : 1
var FechaLimitePago=''


if(TipoPago==2){
  var fechiLimit=new Date()
  var CantF= GASTOS.dgastos.diascredito!=null? GASTOS.dgastos.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}



var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,fechaVencimiento)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)}
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
      </IdDoc> ${this.getEmisorFactEletroECF(GASTOS)} 
     <Comprador>
      <RNCComprador>${RNCComprador.replaceAll('&', '&amp;')}</RNCComprador>
      <RazonSocialComprador>${SocialComprador.replaceAll('&', '&amp;')}</RazonSocialComprador>
    </Comprador>${this.getTotalGastoPROINF(GASTOS)}
  </Encabezado>
  <DetallesItems>${this.getDetalleItemsGasto_PROINF(GASTOS)}
  </DetallesItems>
  <FechaHoraFirma>${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
// ${this.getTotalFactEletroECF(FACTURA)}
  return FAC_STRING.trim()
},

getDetalleItemsGasto_PROINF(GASTOS){

 var VARDET=""
 var NumeroLinea=1 
 var IndicadorFacturacion = GASTOS.dgastos.hasOwnProperty("impuesto")&& GASTOS.dgastos.impuesto!=null && GASTOS.dgastos.impuesto>0?1:4;

 //${(this.RedondeoValorCantRed(GASTOS.dgastos.montoservicios,2)).toFixed(2)}
var BOOL_BienoServicio= GASTOS.dgastos.montoservicios!=null && GASTOS.dgastos.montoservicios>0 && GASTOS.dgastos.montobienes!=null&& GASTOS.dgastos.montobienes>0?true:false;
var MontoITBISRetenido= BOOL_BienoServicio==true? GASTOS.dgastos.retencion/2 : GASTOS.dgastos.retencion
var MontoISRRetenido=   BOOL_BienoServicio==true? GASTOS.dgastos.visr/2 : GASTOS.dgastos.visr

  var Retencion=``
  // if(GASTO.dgastos.retencion!=null&&GASTO.dgastos.retencion>0 ){ }
    Retencion=`
    <Retencion>
      <IndicadorAgenteRetencionoPercepcion>1</IndicadorAgenteRetencionoPercepcion>
      <MontoITBISRetenido>${(this.RedondeoValorCantRed(MontoITBISRetenido,2)).toFixed(2)}</MontoITBISRetenido>
      <MontoISRRetenido>${(this.RedondeoValorCantRed(MontoISRRetenido,2)).toFixed(2)}</MontoISRRetenido>
    </Retencion>`
 var NOMB_ITEMS= GASTOS.dgastos.concepto.trim()


if(GASTOS.dgastos.montobienes!=null && GASTOS.dgastos.montobienes>0 ){
var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IndicadorFacturacion}</IndicadorFacturacion>${Retencion}
      <NombreItem>${(NOMB_ITEMS.trim()+' (BIENES)').replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(GASTOS.dgastos.montobienes,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(GASTOS.dgastos.montobienes,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
 }

 if(GASTOS.dgastos.montoservicios!=null && GASTOS.dgastos.montoservicios>0 ){
var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>${IndicadorFacturacion}</IndicadorFacturacion>${Retencion}
      <NombreItem>${(NOMB_ITEMS.trim()+' (SERVICIO)').replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>2</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(GASTOS.dgastos.montoservicios,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(GASTOS.dgastos.montoservicios,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
 }

 return VARDET
},

getTotalGastoPROINF(GASTOS){

  var TOTAL=''

if( GASTOS.dgastos.hasOwnProperty('impuesto') && GASTOS.dgastos.impuesto!=null && GASTOS.dgastos.impuesto>0){
  TOTAL=`
  <Totales>
  <MontoGravadoTotal>${(this.RedondeoValorCantRed(GASTOS.dgastos.valor,2)).toFixed(2)}</MontoGravadoTotal>
  <MontoGravadoI1>${ (this.RedondeoValorCantRed(GASTOS.dgastos.valor,2)).toFixed(2)   }</MontoGravadoI1>
  <ITBIS1>18</ITBIS1>
  <TotalITBIS>${ (this.RedondeoValorCantRed(GASTOS.dgastos.impuesto,2)).toFixed(2)   }</TotalITBIS>
  <TotalITBIS1>${(this.RedondeoValorCantRed(GASTOS.dgastos.impuesto,2)).toFixed(2)}</TotalITBIS1>
  <MontoTotal>${(this.RedondeoValorCantRed((GASTOS.dgastos.valor+GASTOS.dgastos.impuesto),2)).toFixed(2)}</MontoTotal>
  <TotalITBISRetenido>${(this.RedondeoValorCantRed(GASTOS.dgastos.retencion,2)).toFixed(2)}</TotalITBISRetenido>
  <TotalISRRetencion>${ (this.RedondeoValorCantRed(GASTOS.dgastos.visr,2)).toFixed(2) }</TotalISRRetencion>
</Totales>`
}else{
  TOTAL=`
  <Totales>
 <MontoExento>${(this.RedondeoValorCantRed((GASTOS.dgastos.valor+GASTOS.dgastos.impuesto),2)).toFixed(2)}</MontoExento>
  <MontoTotal>${(this.RedondeoValorCantRed((GASTOS.dgastos.valor+GASTOS.dgastos.impuesto),2)).toFixed(2)}</MontoTotal>
  <TotalITBISRetenido>${(this.RedondeoValorCantRed(GASTOS.dgastos.retencion,2)).toFixed(2)}</TotalITBISRetenido>
  <TotalISRRetencion>${ (this.RedondeoValorCantRed(GASTOS.dgastos.visr,2)).toFixed(2) }</TotalISRRetencion>
</Totales>`
}

return  TOTAL;

},
// -*------------* FIN GASTOS PROVEEDORES INFORMALES *------------


// -*------------* ANULACION DE GASTOS *------------

async procesarTokenXML_ECF_ANULACIONGASTOS(GASTOS,CODMOF){
var GASTO_DATA=JSON.parse(JSON.stringify(GASTOS))
GASTO_DATA.caja={sucursal:GASTOS.sucursal}
 var Ahora= new Date()
  var expedido= GASTOS.sucursal.expedido
  var expira= GASTOS.sucursal.expira
  var token= GASTOS.sucursal.token

   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  //  if(this.semilla!=null)
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
      const resPROFAC_ECF =  await this.procesarAnulacionGastoXML_ECF(GASTO_DATA,resObjToken,CODMOF);
      return resPROFAC_ECF;
  }else{
    const resPROFAC_ECF =  await this.procesarAnulacionGastoXML_ECF(GASTO_DATA,SEMILLA,CODMOF);
     return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(GASTO_DATA);
    const resPROFAC_ECF =  await this.procesarAnulacionGastoXML_ECF(GASTO_DATA,resObjToken,CODMOF);
    return resPROFAC_ECF;
  }

},

async procesarAnulacionGastoXML_ECF(GASTO,resObjToken,CODMOF){

   //var FACT =JSON.parse(JSON.stringify(DEV.facturasventa))
 var ObjDirecSucursal={
nombreCertDGI:GASTO.caja.sucursal.nombreArchivoDgi,
passCertDGI:GASTO.caja.sucursal.passCertDgi,
sucursalRnc:GASTO.caja.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }
 // var AMBIENTE= this.ambiente
 var AMBIENTE=GASTO.sucursal.ambienteDgi!=null?GASTO.sucursal.ambienteDgi:"testecf";
const resXMLConvert = await this.AnulacionGastoXMLeCF(GASTO,CODMOF);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =GASTO.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+GASTO.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=GASTO.cedularncncf!=null? GASTO.cedularncncf.trim().replace("-", "").replace(/-/g,''):"";
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
var ObjCOMPLETO={};
//  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim().replaceAll(' ', '%20')
 //var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
 // ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
// * ObjCOMPLETO.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
 //*ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}&rnccomprador=${cedularncncf}&encf=${DEV.ncf.trim()}&fechaemision=${this.FormatoFecha(DEV.nuevaFecha)}&montototal=${DEV.valor}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 //ORIGINAL
// ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${GASTO.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTO.nuevaFechaAnunlacion)}&montototal=${GASTO.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 
 const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${GASTO.ncf.trim()}&fechaemision=${this.FormatoFecha(GASTO.nuevaFechaAnunlacion)}&montototal=${GASTO.valor.toFixed(2)}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
 ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},

AnulacionGastoXMLeCF(GASTO,CODMOF){ 

var eNCF=GASTO.ncf.trim()
var MontoTotal= GASTO.valor;
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
var FechaLimitePago=''
if(GASTO.cxc>0){
  TipoPago=2
  var fechiLimit=new Date()
  var CantF= GASTO.diascredito!=null? GASTO.diascredito: 30
  fechiLimit.setDate(fechiLimit.getDate() + CantF);
  fechiLimit =new Date(fechiLimit)
  FechaLimitePago=`
  <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
  `
}
var TipoeCF= eNCF.substr(1,2)
var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var ahora=this.fechaNueva()

var DATA_GAST_ANU={
  descripcion:GASTO.descripcion.trim().replaceAll('&', '&amp;').substr(0,79),
  ncfFac:GASTO.ncf.trim(),
  sucursal:GASTO.sucursal,
  nuevaFecha:GASTO.nuevaFechaAnunlacion,
  nuevaFechaFac:GASTO.nuevafechaRegModificado,
  valor:GASTO.valor,
  valorimpuesto:GASTO.valorItbis,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora)
}
// ${this.getIndicadorNotaCredito(ahora,GASTO.nuevafechaRegModificado)}
var RNCComprador =GASTO.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
var SocialComprador=GASTO.sucursal.razonSocialDgi.trim()
// ${this.getTipoIngresos(TipoeCF)}
  var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF> ${this.getIndicadorNotaCredito(DATA_GAST_ANU.nuevaFecha,GASTO.nuevafechaRegModificado)} ${this.getIndicadorMontoGravado(TipoeCF,IndicadorMontoGravado)} 
      <TipoPago>${TipoPago}</TipoPago>${FechaLimitePago}
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_GAST_ANU)} 
    <Comprador>
      <RNCComprador>${RNCComprador.replaceAll('&', '&amp;')}</RNCComprador>
      <RazonSocialComprador>${SocialComprador.replaceAll('&', '&amp;')}</RazonSocialComprador>
    </Comprador>
  	${this.getTotalAnulacionGasto_EletroECF(DATA_GAST_ANU)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsAnulacionGasto(DATA_GAST_ANU)}
  </DetallesItems>
  <InformacionReferencia>
<NCFModificado>${GASTO.ncfModificado}</NCFModificado>
<FechaNCFModificado>${this.FormatoFecha(DATA_GAST_ANU.nuevaFechaFac)}</FechaNCFModificado>
<CodigoModificacion>${CODMOF}</CodigoModificacion>
</InformacionReferencia>
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`
//13-09-2024 17:11:44

return FAC_STRING.trim();

},


getTotalAnulacionGasto_EletroECF(DATA_DAT){
var TOTAl_STRING=``

if(DATA_DAT.valorimpuesto!=null && DATA_DAT.valorimpuesto>0){
TOTAl_STRING=`
<Totales>
<MontoGravadoTotal>${DATA_DAT.valor}</MontoGravadoTotal>
<MontoGravadoI1>${DATA_DAT.valor}</MontoGravadoI1>
<ITBIS1>18</ITBIS1>
<TotalITBIS>${DATA_DAT.valorimpuesto}</TotalITBIS>
<TotalITBIS1>${DATA_DAT.valorimpuesto}</TotalITBIS1>
<MontoTotal>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoTotal>
</Totales>
`

}else{

TOTAl_STRING=`
<Totales>
<MontoExento>${DATA_DAT.valor}</MontoExento>
<MontoTotal>${DATA_DAT.valor}</MontoTotal>
</Totales>`

}

  return TOTAl_STRING
},
getDetallesItemsAnulacionGasto(DATA_DAT){
  
  var IND_FACT=4
  if(DATA_DAT.valorimpuesto>0){IND_FACT=1}
var ITEM_STRING=`
<Item>
<NumeroLinea>1</NumeroLinea>
<IndicadorFacturacion>${IND_FACT}</IndicadorFacturacion>
<NombreItem>${DATA_DAT.descripcion.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
<IndicadorBienoServicio>1</IndicadorBienoServicio>
<CantidadItem>1</CantidadItem>
<UnidadMedida>43</UnidadMedida>
<PrecioUnitarioItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</PrecioUnitarioItem>
<MontoItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoItem>
</Item>`

/*var ITEM_STRING=`
<Item>
      <NumeroLinea>1</NumeroLinea>
      <NombreItem>Ajuste por diferencia de precio (ND)</NombreItem>
      <Cantidad>1</Cantidad>
      <PrecioUnitario>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</PrecioUnitario>
      <MontoItem>${DATA_DAT.valor+DATA_DAT.valorimpuesto}</MontoItem>
    </Item>`*/
return ITEM_STRING;

},

// -*------------* FIN ANULACION DE GASTOS *------------

//Recepción de e‐CF: 
getSignatureValue(SIGN){ 
//.trim().replaceAll(' ', '%20')
var SIGN_VALUE=SIGN.trim().replaceAll('%', '%25').replaceAll(' ', '%20').replaceAll('!', '%21').replaceAll('#', '%23').replaceAll('$', '%24').replaceAll('&', '%26').replaceAll("'", '%27').replaceAll('(', '%28').replaceAll(')', '%29').replaceAll('*', '%2A').replaceAll('+', '%2B').replaceAll(',', '%2C').replaceAll('/', '%2F').replaceAll(':', '%3A').replaceAll(';', '%3B');
SIGN_VALUE=SIGN_VALUE.replaceAll('=', '%3D').replaceAll('?', '%3F').replaceAll('@', '%40').replaceAll('[', '%5B').replaceAll(']', '%5D').replaceAll('"', '%22').replaceAll('-', '%2D').replaceAll('.', '%2E').replaceAll('<', '%3C').replaceAll('>', '%3E').replaceAll('^', '%5E').replaceAll('_', '%5F').replaceAll('`', '%60').replaceAll(/\\/g, "%5C");

return SIGN_VALUE.trim();

},  

validarPlazoEnvioDgii(control) {
  if (control && !control.envioIniciado && (control.cancelado || Date.now() >= control.limite)) {
    control.cancelado = true;
    const error = new Error("Envio cancelado antes de transmitir: tiempo de espera agotado");
    error.code = "DGII_ENVIO_CANCELADO";
    throw error;
  }
},

async envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal,control){
  if (ObjCOMPLETO.usarCola) {
    const headers = Object.assign({}, control && control.headers || this.$store.getters.GetheadersAxios);
    const form = new FormData();
    form.append('xml', new Blob([ObjCOMPLETO.xmlSellada], { type: 'application/xml' }), ObjCOMPLETO.nombreXml + '.xml');
    if (ObjCOMPLETO.xmlCompleto) form.append('xmlCompleto', new Blob([ObjCOMPLETO.xmlCompleto], { type: 'application/xml' }), ObjCOMPLETO.nombreXml + '-ecf.xml');
    form.append('ambiente', ObjCOMPLETO.ambiente);
    form.append('qr', ObjCOMPLETO.qrdgii || '');
    form.append('fecha', ObjCOMPLETO.fechafirmadgii || '');
    form.append('codigo', ObjCOMPLETO.signatureValue || '');
    const base = this.$hostname + this.$hName + '/pv/ecf-cola';
    const guardado = await this.$axios.post(base + '/registrar', form, { headers });
    if (control) { control.ecfRegistrado = true; control.ecfId = guardado.data.id; }
    const impresion = guardado.data.xmlRegistrado === true && guardado.data.impresion;
    if (impresion) {
      if (!impresion.rnc || !impresion.encf || ObjCOMPLETO.nombreXml !== impresion.rnc + impresion.encf) {
        throw new Error("El XML registrado pertenece a otro comprobante; no se iniciara el envio.");
      }
      if (control) control.datosImpresion = Object.assign({}, impresion);
      // Una llamada repetida puede encontrar un original previo: conservar su QR y firma.
      for (const campo of ['qrdgii', 'signatureValue', 'fechafirmadgii']) {
        if (typeof impresion[campo] === 'string' && impresion[campo].trim()) ObjCOMPLETO[campo] = impresion[campo];
      }
    }
    if (control && control.soloRegistrar) {
      if (guardado.data.xmlRegistrado !== true) {
        throw new Error("La factura existe en la cola, pero no se confirmo su XML. Revise el historico y la version de la API; no se autoriza reenviar.");
      }
      return guardado.data.resultado;
    }
    // Registrar no envia a DGII. Al vencer el plazo, el coordinador se encarga mas tarde.
    this.validarPlazoEnvioDgii(control);
    if (control) {
      if (typeof control.alIniciarProceso === 'function') control.alIniciarProceso();
      control.envioIniciado = true;
    }
    try {
      const params = control && control.limite ? { limiteEnvio: control.limite } : {};
      const respuesta = await this.$axios.post(base + '/' + guardado.data.id + '/procesar', {}, { headers, params });
      return respuesta.data;
    } catch (error) {
      // El XML ya quedo persistido. Una respuesta perdida no habilita otro envio.
      const pendiente = error instanceof Error ? error : new Error(String(error));
      pendiente.ecfRegistrado = true;
      pendiente.ecfId = guardado.data.id;
      throw pendiente;
    }
  }
 
  // console.log('Inf-envioXmlSelladoENDPOINT->',ObjCOMPLETO)

  return  new Promise((resolve, reject) => {  
    //var AMBIENTE='testecf'
   

    let texto = ObjCOMPLETO.xmlSellada
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, `${ObjCOMPLETO.nombreXml}.xml`);  
 formData.append('ambiente', ObjCOMPLETO.ambiente);
 formData.append('nombreCertDGI', ObjDirecSucursal.nombreCertDGI);
 formData.append('passCertDGI', ObjDirecSucursal.passCertDGI);
 formData.append('sucursalRnc', ObjDirecSucursal.sucursalRnc);

        var headHEAD={ } ;
         headHEAD["Content-Type"] = "multipart/form-data"
        //  headHEAD["accept"]= "application/json"
         headHEAD["Authorization"]= "Bearer "+ObjCOMPLETO.ObjToken.token
         
        
this.validarPlazoEnvioDgii(control);
// Desde este punto un fallo es incierto: no cancelar ni repetir el POST.
if (control) control.envioIniciado = true;
var url2=this.$hostname + this.$hName +`/dgii/recepcion/ecf`
this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          resolve(resss.data)
         })
         .catch((error) => {

          let msg = "";
          if (error.response) {
            msg = error.response.data
          } else if (error.request) {
            msg = error.request.data
          } else {
            msg = error.message;
          }
          resolve(msg)
        });

  });
},

async descargarXml(XML,NOMBRE_XML){
  const reader = new FileReader();

  (async () => { 
         /* xmlString= e.target.result;  
         console.log('xml-->',xmlString)*/
           let blob = new Blob([XML], { type: 'application/xml' });
           let archivo = new File([blob], `${NOMBRE_XML}.xml`, { type: 'text/xml' });  
          // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
            let dataTransfer = new DataTransfer(); 
            dataTransfer.items.add(archivo); 
            /*Descargado el archivo*/ 
            /**/const file = dataTransfer.files[0];
            const url = URL.createObjectURL(file);  
             const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
              a.click();
              URL.revokeObjectURL(url);/**/
            })()
},


// -*------------* PAGO PROVEEDORES EXTRANJERO *------------

async procesarTokenXML_ECF_PAGOPROVEED_EXTRANJERO(DAT){

  var ObjDirecSucursal={
      sucursal:DAT.documentoproveedor.sucursal
  }

var FACTURA =JSON.parse(JSON.stringify(DAT))

 var Ahora= new Date()
  var expedido= ObjDirecSucursal.sucursal.expedido
  var expira= ObjDirecSucursal.sucursal.expira
  var token= ObjDirecSucursal.sucursal.token


   var NEW_EXPIRA =new Date(expira)
   NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
   NEW_EXPIRA=new Date(NEW_EXPIRA)
  // if(this.semilla!=null) 
  if(expira!=null){
    var SEMILLA={
      expedido: expedido,
      expira: expira,
      token: token
    }
    var Ahora= new Date();
    var NEW_EXPIRA =new Date(expira)
    NEW_EXPIRA.setMinutes(NEW_EXPIRA.getMinutes() - 8);
    NEW_EXPIRA=new Date(NEW_EXPIRA)
    if(Ahora>=NEW_EXPIRA){
      const resObjToken =  await this.getSemillaValidaGetToken(ObjDirecSucursal);
      const resPROFAC_ECF =  await this.procesarPAGOPROVEED_EXTRANJERO_XML_ECF(DAT,resObjToken);
      return resPROFAC_ECF;
  }else{

   const resPROFAC_ECF =  await this.procesarPAGOPROVEED_EXTRANJERO_XML_ECF(DAT,SEMILLA);
    return resPROFAC_ECF;
  }

  }else{
    const resObjToken =  await this.getSemillaValidaGetToken(ObjDirecSucursal);
    const resPROFAC_ECF =  await this.procesarPAGOPROVEED_EXTRANJERO_XML_ECF(DAT,resObjToken);
    return resPROFAC_ECF;
  }


},

async procesarPAGOPROVEED_EXTRANJERO_XML_ECF(DAT,resObjToken){
 var FACT =JSON.parse(JSON.stringify(DAT))
 var ObjDirecSucursal={
nombreCertDGI:FACT.documentoproveedor.sucursal.nombreArchivoDgi,
passCertDGI:FACT.documentoproveedor.sucursal.passCertDgi,
sucursalRnc:FACT.documentoproveedor.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
 }

 var TotalISRRet=DAT.pagoproveedoresDetalleList.reduce((total, item) => total + item.retencion, 0);
  var TotalAbono=DAT.pagoproveedoresDetalleList.reduce((total, item) => total + item.abono, 0);
  var valorfact=(TotalAbono+TotalISRRet).toFixed(2)

 var AMBIENTE=FACT.documentoproveedor.sucursal.ambienteDgi!=null?FACT.documentoproveedor.sucursal.ambienteDgi:"testecf";

  const resXMLConvert = await this.PAGOPROVEED_EXTRANJERO_XMLeCF(DAT);
  const resXMLSellada = await this.firmarArchivoXML(resXMLConvert,ObjDirecSucursal);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  //var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var RNCEmisor =ObjDirecSucursal.sucursalRnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+DAT.ncf.trim();
  var fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
  var cedularncncf=FACT.proveedor.idExtranjero!=null? FACT.proveedor.idExtranjero.trim().replace("-", "").replace(/-/g,''):"";
  const signatureValue = await this.getSignatureValue(resXMLSellada.split("<SignatureValue>")[1].substr(0,6));
  var rnccomprador= cedularncncf!=null && cedularncncf.trim().length>0?`&rnccomprador=${cedularncncf}`:'';
   
var ObjCOMPLETO={};
 const resff = resXMLSellada.match(/<FechaHoraFirma>(.*?)<\/FechaHoraFirma>/);
  fechafirmadgii = resff ? resff[1] : `${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`;
  var VAR_FECA_DGII=fechafirmadgii.trim().replaceAll(' ', '%20')
  ObjCOMPLETO.qrdgii=`https://ecf.dgii.gov.do/${AMBIENTE}/consultatimbre?rncemisor=${RNCEmisor}${rnccomprador}&encf=${DAT.ncf.trim()}&fechaemision=${this.FormatoFecha(DAT.nuevaFecha)}&montototal=${valorfact}&fechafirma=${VAR_FECA_DGII}&codigoseguridad=${signatureValue}`;
  ObjCOMPLETO.fechafirmadgii=fechafirmadgii.trim()
 
 ObjCOMPLETO.signatureValue=resXMLSellada.split("<SignatureValue>")[1].substr(0,6)
 ObjCOMPLETO.ObjToken=resObjToken;
 ObjCOMPLETO.trackId="";
 ObjCOMPLETO.xmlSellada=resXMLSellada
 ObjCOMPLETO.nombreXml=NombreXml
 ObjCOMPLETO.ambiente=AMBIENTE

 const objtrackId =  await this.envioXmlSelladoENDPOINT(ObjCOMPLETO,ObjDirecSucursal)
//this.descargarXml(resXMLSellada,NombreXml)
 ObjCOMPLETO.objtrackId=objtrackId
 return ObjCOMPLETO

},


PAGOPROVEED_EXTRANJERO_XMLeCF(DAT){
var  FACTURA=JSON.parse(JSON.stringify(DAT))
var eNCF=DAT.ncf.trim()
var MontoTotal= DAT.valor.toFixed(2);
// var fechaVencimiento=this.FormatoFecha(FACTURA.ncfVencimientonuevaFecha)
// a) Código Tipo: 1: Contado 2: Crédito 3: Gratuito  
var TipoPago=1
// var FechaLimitePago=''
// if(FACTURA.cxc>0){
//   TipoPago=2
//   var fechiLimit=new Date()
//   var CantF= FACTURA.diascredito!=null? FACTURA.diascredito: 30
//   fechiLimit.setDate(fechiLimit.getDate() + CantF);
//   fechiLimit =new Date(fechiLimit)
//   FechaLimitePago=`
//   <FechaLimitePago>${this.FormatoFecha(fechiLimit)}</FechaLimitePago>
//   `
// }
//var TipoeCF= FACTURA.tipocomprobante.hasOwnProperty('tipoEcf') && FACTURA.tipocomprobante.tipoEcf!=null?FACTURA.tipocomprobante.tipoEcf:'';
var TipoeCF= eNCF.substr(1,2)

var IncluirItbisGeneral =this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido;
// 0: no tienen ITBIS incluido. / 1: se encuentran con ITBIS incluido.
var IndicadorMontoGravado = IncluirItbisGeneral==true?1:0
var ahora=this.fechaNueva()
var DATA_FAC_DAT={
  ncfFac:FACTURA.ncf.trim(),
  sucursal:FACTURA.documentoproveedor.sucursal,
  nuevaFecha:DAT.nuevaFecha,
  nuevaFechaFac:FACTURA.nuevaFecha,
  valor:DAT.valor.toFixed(2),
  //valorimpuesto:DAT.valorItbis,
  valorimpuesto:0.00,
  tipocomprobante:{tipoEcf:TipoeCF},
  ListDet:[],
  fechAhora:this.FormatoFecha(ahora),
  valorfact:0.00,
  fechaVencimiento:this.FormatoFecha(DAT.ncfVencimientonuevaFecha),
  tipoPago:1,
  idExtranjero: DAT.proveedor.idExtranjero,
  nombreDgii:DAT.proveedor.nombre.trim(),
  TotalISRRet:DAT.pagoproveedoresDetalleList.reduce((total, item) => total + item.retencion, 0),
  TotalAbono:DAT.pagoproveedoresDetalleList.reduce((total, item) => total + item.abono, 0),
  moneda:DAT.moneda
}

DATA_FAC_DAT.valorfact=(DATA_FAC_DAT.TotalAbono+DATA_FAC_DAT.TotalISRRet).toFixed(2)

var LIST_DEV=[]
 /*Promise.all(DAT.facturasventaDetalleList.map(async (element) => { 
   //var ObjProRow = DEV.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos.codigo == element.producto.codigo && ee.unidades.codigo == element.unidad.codigo && ee.precio == element.precio);
   //ObjProRow[0].cantidad=element.cantidad
   //LIST_DEV.push(ObjProRow[0])
  }));*/
DATA_FAC_DAT.ListDet=FACTURA.pagoproveedoresDetalleList
console.log('verr-DATA_FAC_DAT->',DATA_FAC_DAT)
//DATA_FAC_DAT.ListDet=LIST_DEV
var COMENT_NC= DAT.hasOwnProperty('concepto') && DAT.concepto!=null && DAT.concepto.trim().length>0? DAT.concepto :'';
var FAC_STRING=`
<?xml version="1.0" encoding="utf-8"?>
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    <IdDoc>
      <TipoeCF>${TipoeCF}</TipoeCF>   
      <eNCF>${eNCF}</eNCF>${this.getFechaVencimientoSecuencia(TipoeCF,DATA_FAC_DAT.fechaVencimiento)}
      <TipoPago>${DATA_FAC_DAT.tipoPago}</TipoPago>${this.getFormaDePagoFACTELECT(DAT)}
    </IdDoc> ${this.getEmisorFactEletroECF(DATA_FAC_DAT)} ${this.getCompradorPagoProveed_Extranjero(DATA_FAC_DAT)}
  	${this.getTotalPagoProveeExtre_EletroECF(DATA_FAC_DAT)} ${this.getOtraMoneda(DATA_FAC_DAT)}
  </Encabezado>
  <DetallesItems>${this.getDetallesItemsPagoProvee_Extranjero(DATA_FAC_DAT)}
  </DetallesItems>
  <FechaHoraFirma>${this.FormatoFecha(ahora)} ${this.getHoraActual().substr(0,5)}:00</FechaHoraFirma>
</ECF>`


//return
//13-09-2024 17:11:44
return FAC_STRING.trim();

},

getCompradorPagoProveed_Extranjero(FACTURA){
 /* console.log('Comprador-FACTURA->',FACTURA)
   console.log('Comprador-nombreDgii->',FACTURA.nombreDgii)
  console.log('Comprador-cedularncncf->',FACTURA.cedularncncf)*/
//.replaceAll(".","").replaceAll(",","").replaceAll("-","")
  var SocialComprador=  FACTURA.nombreDgii==null || FACTURA.nombreDgii.trim().length==0?'CONTADO':FACTURA.nombreDgii.trim().toUpperCase();
  var RNCComprador= "";
  if(RNCComprador.length==0 && FACTURA.hasOwnProperty('idExtranjero') && FACTURA.idExtranjero!=null && FACTURA.idExtranjero.trim().length> 0){
    RNCComprador=FACTURA.idExtranjero.trim().replace("-", "").replace(/-/g,'')
  }
 var COMPRADOR=""
 if(RNCComprador.trim().length>0){
  COMPRADOR=`
    <Comprador>
      <IdentificadorExtranjero>${RNCComprador.replaceAll('&', '&amp;')}</IdentificadorExtranjero>
      <RazonSocialComprador>${SocialComprador.replaceAll('&', '&amp;')}</RazonSocialComprador>
    </Comprador>`
 }
    return COMPRADOR;

},

getTotalPagoProveeExtre_EletroECF(FACTURA){

  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valorfact,2).toFixed(2);
  var TotalISRRet= this.RedondeoValorCantRed(FACTURA.TotalISRRet,2).toFixed(2);
  //var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTALXML=''

var TOTAL=`
<Totales>
<MontoExento>${MontoTotal}</MontoExento>
<MontoTotal>${MontoTotal}</MontoTotal>
<TotalISRRetencion>${TotalISRRet}</TotalISRRetencion>
</Totales>
  `
return TOTAL.replaceAll("-0", "0");

},


getDetallesItemsPagoProvee_Extranjero(FACTURA){

var MONTO_GENERAL=0
MONTO_GENERAL=FACTURA.valor;
var ListDetPROV=JSON.parse(JSON.stringify(FACTURA.ListDet))


/* Promise.all(ListDetPROV.map(async (element) => {
       var IND_FACT=4
       var VALOR_DESC=0
    if(IND_FACT==4){VALOR_DESC_NCExento+=(VALOR_DESC)}
    }));

  var VARDET=""
  var NumeroLinea=1 

if(VALOR_DESC_NCExento>0){ 
 var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>4</IndicadorFacturacion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>1</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(VALOR_DESC_NCExento,2)).toFixed(2)}</PrecioUnitarioItem>
      <MontoItem>${(this.RedondeoValorCantRed(VALOR_DESC_NCExento,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
}*/

var Tasa=this.RedondeoValorCantRed(FACTURA.moneda.tasa,4).toFixed(4);

  var VARDET=""
  var NumeroLinea=1 
Promise.all(ListDetPROV.map(async (element) => {
  
  var NOMB_ITEMS=""

if(element.facturasProveedores!=null){
 NOMB_ITEMS=`FACTPRO:${element.facturasProveedores.documentoproveedor.nombrecorto.trim()}-${element.facturasProveedores.facturasProveedoresPK.codigo}. ${element.facturasProveedores.hasOwnProperty('referencia') && element.facturasProveedores.referencia!=null && element.facturasProveedores.referencia.trim().length>0?` REF: ${element.facturasProveedores.referencia.trim()} `:'' }`
}

if(element.gastos!=null){
 NOMB_ITEMS=`FACTPRO:${element.gastos.documentocontable.nombrecorto.trim()}-${element.gastos.gastosPK.secuencia}. ${element.gastos.hasOwnProperty('factura') && element.gastos.factura!=null && element.gastos.factura.trim().length>0?` REF: ${element.gastos.factura.trim()} `:'' }`
}

if(element.notacreditoproveedores!=null){
 NOMB_ITEMS=`FACTPRO:${element.notacreditoproveedores.documentoproveedor.nombrecorto.trim()}-${element.notacreditoproveedores.notacreditoproveedoresPK.codigo}. ${element.notacreditoproveedores.hasOwnProperty('referencia') && element.notacreditoproveedores.referencia!=null && element.notacreditoproveedores.referencia.trim().length>0?` REF: ${element.notacreditoproveedores.referencia.trim()} `:'' }`
}



var otraMoneda="";
//  if(Tasa>1){
//      otraMoneda=`
//     <OtraMonedaDetalle>
// 	  <PrecioOtraMoneda>${this.RedondeoValorCantRed((element.abono+element.retencion)/Tasa,2).toFixed(2)}</PrecioOtraMoneda>
// 	  <MontoItemOtraMoneda>${this.RedondeoValorCantRed((element.abono+element.retencion)/Tasa,2).toFixed(2)}</MontoItemOtraMoneda>
// 	  </OtraMonedaDetalle>
//     `
// }

 var ITEM=`
   <Item>
      <NumeroLinea>${NumeroLinea++}</NumeroLinea>
	    <IndicadorFacturacion>4</IndicadorFacturacion>
        <Retencion>
        <IndicadorAgenteRetencionoPercepcion>1</IndicadorAgenteRetencionoPercepcion>
          <MontoISRRetenido>${(this.RedondeoValorCantRed(element.retencion,2)).toFixed(2)}</MontoISRRetenido>
        </Retencion>
      <NombreItem>${NOMB_ITEMS.trim().replaceAll('&', '&amp;').substr(0,79)}</NombreItem>
      <IndicadorBienoServicio>2</IndicadorBienoServicio>
      <CantidadItem>1</CantidadItem>
      <PrecioUnitarioItem>${(this.RedondeoValorCantRed(element.abono+element.retencion,2)).toFixed(2)}</PrecioUnitarioItem>${otraMoneda}
      <MontoItem>${(this.RedondeoValorCantRed(element.abono+element.retencion,2)).toFixed(2)}</MontoItem> 
    </Item>`
   VARDET+=ITEM
    }));


return VARDET;

},

getOtraMoneda(FACTURA){

  var MontoTotal= this.RedondeoValorCantRed(FACTURA.valorfact,2).toFixed(2);
  var TotalISRRet= this.RedondeoValorCantRed(FACTURA.TotalISRRet,2).toFixed(2);
  var Tasa=this.RedondeoValorCantRed(FACTURA.moneda.tasa,4).toFixed(4);
  //var TotalItbis= this.RedondeoValorCantRed(FACTURA.valorimpuesto,2).toFixed(2);
  var TOTAL='';

  if(Tasa>1){
    //  TOTAL=`
    // <OtraMoneda>
    //   <TipoMoneda>${FACTURA.moneda.nombrecorto.trim()}</TipoMoneda>
    //   <TipoCambio>${Tasa}</TipoCambio>
	  // <MontoExentoOtraMoneda>${this.RedondeoValorCantRed(MontoTotal/Tasa,2).toFixed(2)}</MontoExentoOtraMoneda>
	  // <MontoTotalOtraMoneda>${this.RedondeoValorCantRed(MontoTotal/Tasa,2).toFixed(2)}</MontoTotalOtraMoneda>
    // </OtraMoneda>
    //   `
}

return TOTAL.replaceAll("-0", "0");

},


// -*------------* FIN PAGO PROVEEDORES EXTRANJERO *------------


alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        // this.limpiarPuntoVentaCompleto();
      }
      if (l == "bien2") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        this.ejecucion = true
        this.loading(false)
        this.nuevoRegistro()

      }
      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 120000
        this.ejecucion = true;
        this.loading(false)
      }
    },  

    loading(e) {
      EventBus.$emit("loading", e);
    },



  },
  computed: { 
    GetEjecucion() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
     },

},
};
</script>
<style lang="scss">
</style>
